
// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { Config } from '../.env.js';
// import { useLocation } from 'react-router-dom';
// import RejectModal from './resonModal.js';

// const Table = () => {
//   const [data, setData] = useState([]);
//   const [data1, setData1] = useState([]);
//   const location = useLocation();
//   const [filter, setFilter] = useState('');
//   const [campaignFilter, setCampaignFilter] = useState('');
//   const [filteredData, setFilteredData] = useState([]);
//   const [campaigns, setCampaigns] = useState([]);
//   const [filteredCampaigns, setFilteredCampaigns] = useState(campaigns);
//   const [selectedStatus, setSelectedStatus] = useState("");
//   const [campaignNameFilter, setCampaignNameFilter] = useState("");
//   const [sortBy, setSortBy] = useState("date");
//   const [groupByCampaign, setGroupByCampaign] = useState(false);
//   const [sortOrder, setSortOrder] = useState('asc');
//   const [sortedData, setSortedData] = useState(filteredData);
//   const [showModal, setShowModal] = useState(false);
//   const [selectedItem, setSelectedItem] = useState(null);
//   const [selectedReasons, setSelectedReasons] = useState([]);
//   const [customReason, setCustomReason] = useState("");
//   const [reasonFilter, setReasonFilter] = useState('');
//   const [statusFilter, setStatusFilter] = useState('');
//   const [paymentStatusFilter, setPaymentStatusFilter] = useState('');

//   const campaignName = location.state?.campaignName;

//   useEffect(() => {
//     const fetchRefundData = async () => {
//       try {
//         const response = await axios.get(`${Config.API_URL}/api/refund`);
//         setData(response.data);
//       } catch (error) {
//         console.error('Error fetching refund data:', error);
//       }
//     };
//     fetchRefundData();
//   }, []);

//   useEffect(() => {
//     const fetchData1 = async () => {
//       try {
//         const response = await axios.get(`${Config.API_URL}/api/refund-order`);
//         console.log("Refund Order Data:", response.data);
//         setData1(response.data);

//         const uniqueCampaigns = [...new Set(response.data.map((item) => item.campaignName))];
//         setCampaigns(uniqueCampaigns);
//       } catch (error) {
//         console.error('Error fetching data1:', error);
//       }
//     };

//     fetchData1();
//   }, []);

//   const handleCampaignChange = (e) => {
//     setCampaignFilter(e.target.value);
//   };
//   const handlereasonChange = (e) => {
//     setReasonFilter(e.target.value);
//   };
//   const handlestatusChange = (e) => {
//     setStatusFilter(e.target.value);
//   };
//   const handlePaymentStatusChange = (e) => {
//     setPaymentStatusFilter(e.target.value);
//   };

//   useEffect(() => {
//     const getDate = (item) => {
//       return new Date(
//         data1.find((d) => d.order === item.order)?.date || item.createdAt || 0
//       );
//     };

//     if (campaignFilter) {
//       const data1Map = data1.reduce((acc, item) => {
//         if (item.contactId) acc[item.contactId] = item;
//         return acc;
//       }, {});

//       const filteredRefunds = data.filter((item) => {
//         const related = data1Map[item.contactId];
//         return related?.campaignName === campaignFilter;
//       });

//       const refundContactIds = new Set(data.map(item => item.contactId));
//       const filteredMissingTemplates = data1.filter(item =>
//         item.campaignName === campaignFilter && !refundContactIds.has(item.contactId)
//       );

//       const combinedData = [...filteredRefunds, ...filteredMissingTemplates];

//       const uniqueByOrderId = Object.values(
//         combinedData.reduce((acc, item) => {
//           if (!acc[item.order]) acc[item.order] = item;
//           return acc;
//         }, {})
//       );

//       let finalData = uniqueByOrderId;
//       if (reasonFilter) {
//         finalData = finalData.filter((item) =>
//           Array.isArray(item.reasons)
//             ? item.reasons.includes(reasonFilter)
//             : item.reasons === reasonFilter
//         );
//       }

//       // ✅ Sort recent first
//       finalData.sort((a, b) => getDate(b) - getDate(a));

//       setFilteredData(finalData);
//     } else {
//       const refundContactIds = new Set(data.map(item => item.contactId));
//       const uniqueData1 = data1.filter(item => !refundContactIds.has(item.contactId));
//       const combinedData = [...data, ...uniqueData1];

//       const uniqueByOrderId = Object.values(
//         combinedData.reduce((acc, item) => {
//           if (!acc[item.order]) acc[item.order] = item;
//           return acc;
//         }, {})
//       );

//       let finalData = uniqueByOrderId;
//       if (reasonFilter) {
//         finalData = finalData.filter((item) =>
//           Array.isArray(item.reasons)
//             ? item.reasons.includes(reasonFilter)
//             : item.reasons === reasonFilter
//         );
//       }
//       if (statusFilter !== '') {
//         finalData = finalData.filter((item) => item.status === statusFilter);
//       }
//       if (paymentStatusFilter) {
//         finalData = finalData.filter((item) => item.paymentStatus === paymentStatusFilter);
//       }

//       // ✅ Sort recent first
//       finalData.sort((a, b) => getDate(b) - getDate(a));

//       setFilteredData(finalData);
//     }
//   }, [campaignFilter, data, data1, reasonFilter, statusFilter, paymentStatusFilter]);


//   const handleApprove = async (contactId) => {
//     try {
//       const payload = { contactId };
//       await axios.post(`${Config.API_URL}/api/approve-payment`, payload);

//       // update in data
//       setData((prev) =>
//         prev.map((item) =>
//           item.contactId === contactId ? { ...item, status: "Approved" } : item
//         )
//       );

//       // update in data1
//       setData1((prev) =>
//         prev.map((item) =>
//           item.contactId === contactId ? { ...item, status: "Approved" } : item
//         )
//       );

//       // update filteredData as well
//       setFilteredData((prev) =>
//         prev.map((item) =>
//           item.contactId === contactId ? { ...item, status: "Approved" } : item
//         )
//       );
//     } catch (error) {
//       console.error("Error approving contactId:", error);
//     }
//   };

//   const handleOnHold = async (contactId) => {
//     try {
//       const payload = { contactId };
//       await axios.post(`${Config.API_URL}/api/approve-payment`, payload);

//       // update in data
//       setData((prev) =>
//         prev.map((item) =>
//           item.contactId === contactId ? { ...item, status: "Approved" } : item
//         )
//       );

//       // update in data1
//       setData1((prev) =>
//         prev.map((item) =>
//           item.contactId === contactId ? { ...item, status: "Approved" } : item
//         )
//       );

//       // update filteredData as well
//       setFilteredData((prev) =>
//         prev.map((item) =>
//           item.contactId === contactId ? { ...item, status: "Approved" } : item
//         )
//       );
//     } catch (error) {
//       console.error("Error approving contactId:", error);
//     }
//   };

//   const openRejectModal = (item) => {
//     setSelectedItem(item);
//     setSelectedReasons([]);
//     setCustomReason("");
//     setShowModal(true);
//   };

//   const closeRejectModal = () => {
//     setShowModal(false);
//     setSelectedItem(null);
//     setCustomReason("");
//     setSelectedReasons([]);
//   };

//   const toggleReason = (reason) => {
//     setSelectedReasons((prev) =>
//       prev.includes(reason) ? prev.filter((r) => r !== reason) : [...prev, reason]
//     );
//   };



//   const handleSubmitRejection = async () => {
//     if (!selectedItem) return;

//     const finalReasons = selectedReasons.includes('Others')
//       ? [...selectedReasons.filter((r) => r !== 'Others'), customReason]
//       : selectedReasons;

//     try {
//       const orderId = selectedItem.orderId || selectedItem.order;

//       if (!orderId) {
//         console.error("Missing orderId or order in selectedItem", selectedItem);
//         return;
//       }

//       await axios.post(`${Config.API_URL}/api/reject-payment`, {
//         orderId,
//         reasons: finalReasons,
//       });

//       console.log("Submitting rejection for:", selectedItem);

//       setData((prev) =>
//         prev.map((item) =>
//           item.orderId === selectedItem.orderId
//             ? { ...item, status: "Canceled", reasons: finalReasons }
//             : item
//         )
//       );

//       setData1((prev) =>
//         prev.map((item) =>
//           item.orderId === selectedItem.orderId
//             ? { ...item, status: "Canceled", reasons: finalReasons }
//             : item
//         )
//       );

//       setFilteredData((prev) =>
//         prev.map((item) =>
//           item.orderId === selectedItem.orderId
//             ? { ...item, status: "Canceled", reasons: finalReasons }
//             : item
//         )
//       );
//     } catch (error) {
//       console.error("Error canceling order:", error);
//     }

//     closeRejectModal();
//   };



//   const statusOptions = [
//     "Failed",
//     "Processed",
//     "Queue",
//   ];
//   const approve = [
//     "Pending Approval",
//     "Approved",
//     "Canceled",
//     "On-hold",
//   ];
//   const reason = [
//     "Everything is Okay",

//     "Missing Item(s): Order Screenshot",

//     "Missing Item(s): Delivered Screenshot",

//     "Missing Item(s): Review / Rating Screenshot",

//     "Missing Itern(s): Live Review Screenshot",

//     "Missing Item(s): Invoice",

//     "Missing Item(s): Live Review Link",

//     "Mismatched Details: Of Order ID",

//     "Mismatched Details: Of Product ID",

//     "Mismatched Detalls: Of Product Amount",

//     "Mismatched Details: Of Order Date",

//     "Mismatched Details: Of Product",

//     "Mismatched Details: Of Order Screenshot",

//     "Mismatched Details: Of Review Screenshot and Live Review",

//     "Mismatched Details: Of Reviewer Name",

//     "Suspicious Activity: In Order Screenshot",

//     "Suspicious Activity: In Delivered Screenshot",

//     "Suspicious Activity: In the Submitted Review / Rating Screenshot",

//     "Suspicious Activity: In the Live Review Screenshot",

//     "Suspicious Activity: In Live Review Screenshot(Review not verified)",

//     "Suspicious Activity: In Invoice(PDF / Screenshot)",

//     "Suspicious Activity: In Order Status(Product returned)",

//     "Suspicious Activity: In Order Status(Order canceled)",

//     "Suspicious Activity: In Order Status(Order not delivered yet)",

//     "Wrong Documents / Details SubmiNid: Order Screenshot",

//     "Wrong Documents / Details Submitted: Delivered Screenshot",

//     "Wrong Documents / Details Submitted: Review / Rating Screenshot",

//     "Wrong Documents / Details Submitted: Live Review Screenshot",

//     "Wrong Documents / Details Submitted: Invoice",

//     "Wrong Documents / Details Submitted: Live Review Link",

//     "Wrong Documents / Details Submitted, Live Review Screenshot(Not from logged in account)",

//     "Review Quality: Only Rating(No review)",

//     "Review Quality: Oniy Rating Required No review needed)",

//     "Review Quality Very Short Review",

//     "Review Quality: Incorrect Rating",

//     "Review Quallty: Review with Title Only(No Description)",

//     "Review Quallty: Missing Video",

//     "Review Quality: Missing Image",

//     "Review Quality: Missing Keywords",

//     "Review Quality: Wrong Gender",

//     "Screenshot Quality(Resolution) is bad: Order Screenshot",

//     "Screenshot Quality(Resolution) is bad: Delivered Screenshot",

//     "Screenshot Quality(Resolution) is bad: Review / Rating Screenshot",

//     "Screenshot Quality(Resolution) is bad: Live Review Screenshot",

//     "Screenshot Quality(Resolution) is bad: Involce",

//     "Screenshot Completeness(Not Full Page): Order Screenshot",

//     "Screenshot Completeness(Not Full Page): Delivered Screenshot",

//     "Screenshot Completeness(Not Full Page): Review / Rating Screenshot",

//     "Screenshot Completeness(Not Full Page): Live Review Screenshot",

//     "Screenshot Completeness(Not Full Page): Invoice Duplicate",

//     "Shipping Fee Issue: Shipping fee exceeds the limit of the standard fee"
//   ];
//   const handleStatusChange = (event) => {
//     setSelectedStatus(event.target.value);
//     filterCampaigns(campaignNameFilter, event.target.value);
//   };


//   const filterCampaigns = (name, status) => {
//     let filtered = campaigns;

//     if (name) {
//       filtered = filtered.filter((campaign) =>
//         campaign.campaignName.toLowerCase().includes(name.toLowerCase())
//       );
//     }

//     if (status) {
//       filtered = filtered.filter((campaign) => campaign.status === status);
//     }

//     sortCampaigns(filtered, sortBy);
//   };

//   const sortCampaigns = (campaigns, sortOption) => {
//     let sortedCampaigns = [...campaigns];

//     if (sortOption === "date") {
//       sortedCampaigns = sortedCampaigns.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
//     } else if (sortOption === "campaign") {
//       sortedCampaigns = sortedCampaigns.sort((a, b) => a.campaignName.localeCompare(b.campaignName));
//     }

//     setFilteredCampaigns(sortedCampaigns);
//   };

//   const renderCampaigns = () => {
//     if (groupByCampaign) {
//       const groupedCampaigns = filteredCampaigns.reduce((acc, campaign) => {
//         if (!acc[campaign.campaignName]) {
//           acc[campaign.campaignName] = [];
//         }
//         acc[campaign.campaignName].push(campaign);
//         return acc;
//       }, {});
//       return Object.keys(groupedCampaigns).map((campaignName) => (
//         <div key={campaignName}>
//           <h3>{campaignName}</h3>
//           <ul>
//             {groupedCampaigns[campaignName].map((campaign) => (
//               <li key={campaign.id}>
//                 {campaign.campaignName} - {campaign.status} - {campaign.createdAt}
//               </li>
//             ))}
//           </ul>
//         </div>
//       ));
//     } else {
//       return filteredCampaigns.map((campaign) => (
//         <li key={campaign.id}>
//           {campaign.campaignName} - {campaign.status} - {campaign.createdAt}
//         </li>
//       ));
//     }
//   };
//   let isDown = false;
//   let startX;
//   let scrollLeft;

//   const handleMouseDown = (e) => {
//     const slider = e.currentTarget;
//     isDown = true;
//     slider.classList.add('active');
//     startX = e.pageX - slider.offsetLeft;
//     scrollLeft = slider.scrollLeft;
//   };

//   const handleMouseLeave = (e) => {
//     isDown = false;
//     e.currentTarget.classList.remove('active');
//   };

//   const handleMouseUp = (e) => {
//     isDown = false;
//     e.currentTarget.classList.remove('active');
//   };

//   const handleMouseMove = (e) => {
//     if (!isDown) return;
//     e.preventDefault();
//     const slider = e.currentTarget;
//     const x = e.pageX - slider.offsetLeft;
//     const walk = (x - startX) * 2;
//     slider.scrollLeft = scrollLeft - walk;
//   };
//   const handleSortByDate = () => {
//     const newSortOrder = sortOrder === 'asc' ? 'desc' : 'asc';
//     const sorted = [...sortedData].sort((a, b) => {
//       const dateA = new Date(data1.find((d) => d.order === a.order)?.date || '');
//       const dateB = new Date(data1.find((d) => d.order === b.order)?.date || '');

//       if (newSortOrder === 'asc') {
//         return dateA - dateB;
//       } else {
//         return dateB - dateA;
//       }
//     });

//     setSortedData(sorted);
//     setSortOrder(newSortOrder);
//   };

//   return (
//     <div className="container mt-5">

//       {/* Campaign Filter Dropdown */}
//       <div className="filters mb-3">
//         <label htmlFor="campaignFilter" className="mr-2">Filter by Campaign:</label>
//         <select
//           id="campaignFilter"
//           value={campaignFilter}
//           onChange={handleCampaignChange}
//           className="dropdown"
//         >
//           <option value="">All Campaigns</option>
//           {campaigns.map((campaign, index) => (
//             <option key={index} value={campaign}>
//               {campaign}
//             </option>
//           ))}
//         </select>
//       </div>
//       <div className="filters mb-3">
//         <label htmlFor="reasonFilter" className="mr-2">Filter by Reason:</label>
//         <select
//           id="reasonFilter"
//           value={reasonFilter}
//           onChange={handlereasonChange}
//           className="dropdown"
//         >
//           <option value="">All Reason</option>
//           {reason.map((reason, index) => (
//             <option key={index} value={reason}>
//               {reason}
//             </option>
//           ))}
//         </select>
//       </div>
//       <div className="filters mb-3">
//         <label htmlFor="reasonFilter" className="mr-2">Filter by Application Status:</label>
//         <select
//           id="statusFilter"
//           value={statusFilter}
//           onChange={handlestatusChange}
//           className="dropdown"
//         >
//           <option value="">All Reason</option>
//           {approve.map((approve, index) => (
//             <option key={index} value={approve}>
//               {approve}
//             </option>
//           ))}
//         </select>
//       </div>
//       <div className="filters mb-3">
//         <label htmlFor="reasonFilter" className="mr-2">Filter by Payment Status:</label>
//         <select
//           id="paymentStatusFilter"
//           value={paymentStatusFilter}
//           onChange={handlePaymentStatusChange}
//           className="dropdown"
//         >
//           <option value="">All Reason</option>
//           {statusOptions.map((statusOptions, index) => (
//             <option key={index} value={statusOptions}>
//               {statusOptions}
//             </option>
//           ))}
//         </select>
//       </div>

//       {/* <div style={{ marginBottom: "10px" }}>
//         <label>Filter by Reason: </label>
//         <select value={selectedStatus} onChange={handleStatusChange}>
//           <option value="">All</option>
//           {reason.map((status) => (
//             <option key={status} value={status}>
//               {status}
//             </option>
//           ))}
//         </select>
//       </div> */}


//       {/* <div style={{ marginBottom: "10px" }}>
//         <label>Sort by: </label>
//         <select value={sortBy} onChange={handleSortChange}>
//           <option value="date">Date</option>
//           <option value="campaign">Campaign</option>
//         </select>
//       </div> */}

//       {/* Group by campaign name */}
//       {/* <div style={{ marginBottom: "10px" }}>
//         <label>Filter by Brand</label>
//         <input
//           type="checkbox"
//           checked={groupByCampaign}
//           onChange={handleGroupChange}
//         />
//       </div> */}

//       <div className="table is-bordered" style={{ overflowX: 'auto' }}>
//         <div
//           className="table-container"
//           style={{
//             overflowX: 'auto',
//             cursor: 'grab',
//           }}
//           onMouseDown={handleMouseDown}
//           onMouseLeave={handleMouseLeave}
//           onMouseUp={handleMouseUp}
//           onMouseMove={handleMouseMove}
//         >
//           <table className="table is-fullwidth">

//             <thead>
//               <tr>
//                 {/* <th className="customStyle">Brand Name</th> */}
//                 <th className="customStyle">Campaign Name</th>
//                 <th className="customStyle">User Name</th>
//                 <th className="customStyle">Order ID</th>
//                 <th className="customStyle">Quantity</th>
//                 <th className="customStyle">Invoice Number</th>
//                 <th className="customStyle">Product Amount</th>
//                 <th className="customStyle">Deliverable Link</th>
//                 <th className="customStyle">Bank Name</th>
//                 <th className="customStyle">Ifsc</th>
//                 <th className="customStyle">Beneficiary Name</th>
//                 <th className="customStyle">Account Number</th>
//                 <th className="customStyle">UPI Number</th>
//                 <th className="customStyle">Managers</th>
//                 <th className="customStyle" onClick={handleSortByDate} style={{ cursor: 'pointer' }}>
//                   Date {sortOrder === 'asc' ? '↑' : '↓'}
//                 </th>
//                 <th className="customStyle">Student</th>
//                 <th className="customStyle">College</th>
//                 <th className="customStyle">Whatsapp Group</th>
//                 <th className="customStyle">Pin Code</th>
//                 <th className="customStyle">City</th>
//                 <th className="customStyle">Product Name</th>
//                 <th className="customStyle">Order Delivered Screen Shot</th>
//                 <th className="customStyle">Submitting Rating SS</th>
//                 <th className="customStyle">Seller Feedback Screenshot </th>
//                 <th className="customStyle">Invoice Pdf </th>

//                 {/* New Columns for Data1 */}
//                 <th className="customStyle">Order ID</th>
//                 <th className="customStyle">Full Name</th>
//                 <th className="customStyle">Instagram</th>
//                 <th className="customStyle">Facebook</th>
//                 <th className="customStyle">Twitter</th>
//                 <th className="customStyle">YouTube</th>
//                 <th className="customStyle">Custom Social</th>
//                 <th className="customStyle">Gender</th>
//                 <th className="customStyle">Whatsapp</th>
//                 <th className="customStyle">Phone</th>
//                 <th className="customStyle">Custom MarketPlace</th>
//                 <th className="customStyle">Custom Review</th>
//                 <th className="customStyle">Custom Profile Link</th>
//                 <th className="customStyle">Email</th>
//                 <th className="customStyle">Actions</th>
//                 <th className="customStyle">Status</th>
//                 <th className="customStyle"> Payment Status</th>
//               </tr>
//             </thead>
//             <tbody>
//               {filteredData && filteredData.length > 0 ? (
//                 filteredData.map((item, index) => {
//                   const matchedData = data1.find((d) => d.order === item.order);

//                   return (
//                     <tr key={index}>
//                       {/* <td className="customStyle">{matchedData?.brandName || ''}</td> */}
//                       <td className="customStyle">{matchedData?.campaignName || ''}</td>

//                       <td className="customStyle">
//                         {matchedData?.AuthInstagram ? (
//                           <a
//                             href={`https://www.instagram.com/${matchedData.AuthInstagram}`}
//                             target="_blank"
//                             rel="noopener noreferrer"
//                             style={{ color: 'blue', textDecoration: 'underline' }}
//                           >
//                             {matchedData.AuthInstagram}
//                           </a>
//                         ) : (
//                           ''
//                         )}
//                       </td>

//                       <td className="customStyle">{item.order}</td>
//                       <td className="customStyle">{item.inputValue1}</td>
//                       <td className="customStyle">{item.invoiceNumber}</td>
//                       <td className="customStyle">{matchedData?.productAmount || ''}</td>
//                       <td className="customStyle">{item.inputValue2}</td>
//                       <td className="customStyle">{matchedData?.BankName}</td>
//                       <td className="customStyle">{item.ifsc}</td>
//                       <td className="customStyle">{item.beneficiaryName}</td>
//                       <td className="customStyle">{item.accountNumber}</td>
//                       <td className="customStyle">{item.UPI}</td>
//                       <td className="customStyle">
//                         {Array.isArray(matchedData?.managers) ? matchedData.managers.join(', ') : ''}
//                       </td>
//                       <td className="customStyle">{matchedData?.date || ''}</td>
//                       <td className="customStyle">
//                         {String(matchedData?.student) === 'true' ? 'Yes' : 'No'}
//                       </td>
//                       <td className="customStyle">{matchedData?.collegeName || ''}</td>
//                       <td className="customStyle">{item.whatsappGroup}</td>
//                       <td className="customStyle">{matchedData?.pinCode || ''}</td>
//                       <td className="customStyle">{matchedData?.city || ''}</td>
//                       <td className="customStyle">{item.inputValue}</td>

//                       <td className="customStyle">
//                         {item.inputValue3 && (
//                           <a href={`${Config.API_URL}/${item.inputValue3}`} target="_blank" rel="noopener noreferrer">
//                             <img
//                               src={`${Config.API_URL}/${item.inputValue3}`}
//                               alt="Screenshot 1"
//                               style={{ width: '100px', height: 'auto' }}
//                             />
//                           </a>
//                         )}
//                       </td>

//                       <td className="customStyle">
//                         {item.inputValue4 && (
//                           <a href={`${Config.API_URL}/${item.inputValue4}`} target="_blank" rel="noopener noreferrer">
//                             <img
//                               src={`${Config.API_URL}/${item.inputValue4}`}
//                               alt="Screenshot 2"
//                               style={{ width: '100px', height: 'auto' }}
//                             />
//                           </a>
//                         )}
//                       </td>
//                       <td className="customStyle">
//                         {item.sellarFeedbackScreenshot && (
//                           <a href={`${Config.API_URL}/${item.sellarFeedbackScreenshot}`} target="_blank" rel="noopener noreferrer">
//                             <img
//                               src={`${Config.API_URL}/${item.sellarFeedbackScreenshot}`}
//                               alt="Screenshot 2"
//                               style={{ width: '100px', height: 'auto' }}
//                             />
//                           </a>
//                         )}
//                       </td>

//                       <td className="customStyle">
//                         {item.invoiceReceived && (
//                           <a href={`${Config.API_URL}/${item.invoiceReceived}`} target="_blank" rel="noopener noreferrer">
//                             <img
//                               src={`${Config.API_URL}/${item.invoiceReceived}`}
//                               alt="Screenshot 2"
//                               style={{ width: '100px', height: 'auto' }}
//                             />
//                           </a>
//                         )}
//                       </td>


//                       <td className="customStyle">{matchedData?.order || ''}</td>
//                       <td className="customStyle">{matchedData?.FullName || ''}</td>
//                       <td className="customStyle">{matchedData?.AuthInstagram || ''}</td>

//                       <td className="customStyle">
//                         {matchedData?.AuthFacebook ? (
//                           <a
//                             href={`https://www.facebook.com/${matchedData.AuthFacebook}`}
//                             target="_blank"
//                             rel="noopener noreferrer"
//                             style={{ color: 'blue', textDecoration: 'underline' }}
//                           >
//                             {matchedData.AuthFacebook}
//                           </a>
//                         ) : (
//                           ''
//                         )}
//                       </td>

//                       <td className="customStyle">
//                         {matchedData?.AuthTwitter ? (
//                           <a
//                             href={`https://www.x.com/${matchedData.AuthTwitter}`}
//                             target="_blank"
//                             rel="noopener noreferrer"
//                             style={{ color: 'blue', textDecoration: 'underline' }}
//                           >
//                             {matchedData.AuthTwitter}
//                           </a>
//                         ) : (
//                           ''
//                         )}
//                       </td>

//                       <td className="customStyle">
//                         {matchedData?.AuthYouTube ? (
//                           <a
//                             href={`https://www.youtube.com/${matchedData.AuthYouTube}`}
//                             target="_blank"
//                             rel="noopener noreferrer"
//                             style={{ color: 'blue', textDecoration: 'underline' }}
//                           >
//                             {matchedData.AuthYouTube}
//                           </a>
//                         ) : (
//                           ''
//                         )}
//                       </td>

//                       <td className="customStyle">{matchedData?.AuthCustomSocial || ''}</td>
//                       <td className="customStyle">{matchedData?.gender || ''}</td>
//                       <td className="customStyle">{matchedData?.whatsapp || ''}</td>
//                       <td className="customStyle">{matchedData?.Phone || ''}</td>
//                       <td className="customStyle">{matchedData?.customMarketPlaceName || ''}</td>
//                       <td className="customStyle">{matchedData?.review || ''}</td>
//                       <td className="customStyle">{matchedData?.customForoum || ''}</td>
//                       <td className="customStyle">{matchedData?.email}</td>
//                       <td className="customStyle">
//                         {/* <button
//                           onClick={() => handleApprove(item.contactId)}
//                           disabled={item.status === 'Approved' || item.status === 'Canceled'}
//                           className={`button is-primary ${item.status === 'Approved' ? 'is-light' : ''}`}
//                         >
//                           Approve
//                         </button>

//                         <button
//                           onClick={() => openRejectModal(item)}
//                           disabled={item.status === 'Canceled' || item.status === 'Approved'}
//                           className={`button is-danger ${item.status === 'Canceled' ? 'is-light' : ''}`}
//                         >
//                           Cancel
//                         </button>
//                         <button
//                           onClick={() => handleApprove(item.contactId)}
//                           disabled={item.status === 'Approved' || item.status === 'Canceled'|| item.status === 'On-hold'}
//                           className={`button is-primary ${item.status === 'Approved' ? 'is-light' : ''}`}
//                         >
//                           On-hold
//                         </button>
//                       </td> */}
//                         {/* Approve Button */}
//                         <button
//                           onClick={() => handleApprove(item.contactId)}
//                           disabled={
//                             item.status === 'Approved' // already approved
//                           }
//                           className={`button is-primary ${item.status === 'Approved' ? 'is-light' : ''}`}
//                         >
//                           Approve
//                         </button>

//                         {/* Cancel Button */}
//                         <button
//                           onClick={() => openRejectModal(item)}
//                           disabled={
//                             item.status !== 'On-hold' && item.status !== 'Pending Approval'
//                           }
//                           className={`button is-danger ${item.status === 'Canceled' ? 'is-light' : ''}`}
//                         >
//                           Cancel
//                         </button>

//                         {/* On-hold Button */}
//                         <button
//                           onClick={() => handleOnHold(item.contactId)}
//                           disabled={
//                             item.status !== 'Canceled' && item.status !== 'Pending Approval'
//                           }
//                           className={`button is-warning ${item.status === 'On-hold' ? 'is-light' : ''}`}
//                         >
//                           On-hold
//                         </button>
//                       </td>
//                       <td className="customStyle">
//                         {item.status === 'Canceled' ? (
//                           <>
//                             <strong>Rejected</strong>
//                             {item.reasons?.length > 0 && (
//                               <ul style={{ marginTop: '4px', paddingLeft: '16px', color: 'red', fontSize: '12px' }}>
//                                 {item.reasons.map((reason, index) => (
//                                   <li key={index}>- {reason}</li>
//                                 ))}
//                               </ul>
//                             )}
//                           </>
//                         ) : (
//                           <strong>{item.status || 'Pending Approval'}</strong>
//                         )}
//                       </td>
//                       <td className="customStyle">{item.paymentStatus}</td>

//                     </tr>
//                   );
//                 })
//               ) : (
//                 <tr>
//                   <td colSpan="33">No data available</td>
//                 </tr>
//               )}
//             </tbody>

//           </table>
//           <RejectModal
//             isOpen={showModal}
//             onClose={closeRejectModal}
//             onSubmit={handleSubmitRejection}
//             selectedReasons={selectedReasons}
//             toggleReason={toggleReason}
//             customReason={customReason}
//             setCustomReason={setCustomReason}
//           />

//         </div>
//       </div>
//     </div>
//   );
// };

// export default Table;

//working code
// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { Config } from "../.env.js";
// import { useLocation } from "react-router-dom";
// import RejectModal from "./resonModal.js"; // TODO: Rename to reasonModal.js if needed

// const Table = () => {
//   const [data, setData] = useState([]);
//   const [data1, setData1] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const location = useLocation();
//   const [campaignFilter, setCampaignFilter] = useState("");
//   const [filteredData, setFilteredData] = useState([]);
//   const [campaigns, setCampaigns] = useState([]);
//   const [showModal, setShowModal] = useState(false);
//   const [selectedItem, setSelectedItem] = useState(null);
//   const [selectedReasons, setSelectedReasons] = useState([]);
//   const [customReason, setCustomReason] = useState("");
//   const [reasonFilter, setReasonFilter] = useState("");
//   const [statusFilter, setStatusFilter] = useState("");
//   const [paymentStatusFilter, setPaymentStatusFilter] = useState("");
//   const [sortOrder, setSortOrder] = useState("asc");
//   const [brandFilter, setBrandFilter] = useState("");
//   const [brands, setBrands] = useState([]);

//   const campaignName = location.state?.campaignName; // Kept but unused

//   // Fetch refund data
//   useEffect(() => {
//     const fetchRefundData = async () => {
//       try {
//         setLoading(true);
//         const response = await axios.get(`${Config.API_URL}/api/refund`);
//         setData(response.data);
//       } catch (error) {
//         console.error("Error fetching refund data:", error);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchRefundData();
//   }, []);

//   // Fetch order data and extract campaigns
//   // useEffect(() => {
//   //   const fetchData1 = async () => {
//   //     try {
//   //       setLoading(true);
//   //       const response = await axios.get(`${Config.API_URL}/api/refund-order`);
//   //       setData1(response.data);
//   //       // Normalize campaign names (trim and lowercase for consistency)
//   //       const uniqueCampaigns = [
//   //         ...new Set(
//   //           response.data
//   //             .filter((item) => item.campaignName) // Ensure campaignName exists
//   //             .map((item) => item.campaignName.trim())
//   //         ),
//   //       ];
//   //       setCampaigns(uniqueCampaigns);
//   //     } catch (error) {
//   //       console.error("Error fetching data1:", error);
//   //     } finally {
//   //       setLoading(false);
//   //     }
//   //   };
//   //   fetchData1();
//   // }, []);
//   useEffect(() => {
//     const fetchData1 = async () => {
//       try {
//         setLoading(true);
//         const response = await axios.get(`${Config.API_URL}/api/refund-order`);
//         setData1(response.data);
//         // Normalize campaign names (trim for consistency)
//         const uniqueCampaigns = [
//           ...new Set(
//             response.data
//               .filter((item) => item.campaignName) // Ensure campaignName exists
//               .map((item) => item.campaignName.trim())
//           ),
//         ];
//         // Normalize brand names (trim for consistency)
//         const uniqueBrands = [
//           ...new Set(
//             response.data
//               .filter((item) => item.brandName) // Ensure brandName exists
//               .map((item) => item.brandName.trim())
//           ),
//         ];
//         setCampaigns(uniqueCampaigns);
//         setBrands(uniqueBrands); // Set unique brands
//       } catch (error) {
//         console.error("Error fetching data1:", error);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchData1();
//   }, []);
//   // Filter handlers
//   const handleCampaignChange = (e) => setCampaignFilter(e.target.value);
//   const handlereasonChange = (e) => setReasonFilter(e.target.value);
//   const handlestatusChange = (e) => setStatusFilter(e.target.value);
//   const handleBrandChange = (e) => setBrandFilter(e.target.value);
//   const handlePaymentStatusChange = (e) =>
//     setPaymentStatusFilter(e.target.value);
//   const handleResetFilters = () => {
//     setCampaignFilter("");
//     setReasonFilter("");
//     setStatusFilter("");
//     setBrandFilter("");
//     setPaymentStatusFilter("");
//   };

//   // Combine and filter data
//   // useEffect(() => {
//   //   let combinedData = [];

//   //   const normalize = (str) => str?.trim();

//   //   // if (campaignFilter) {
//   //   //   const normalizedFilter = normalize(campaignFilter);

//   //   //   const data1Map = data1.reduce((acc, item) => {
//   //   //     if (item.campaignName) {
//   //   //       acc[item.campaignName] = item;
//   //   //     }
//   //   //     return acc;
//   //   //   }, {});

//   //   //   const filteredRefunds = data.filter((item) => {
//   //   //     const related = data1Map[item.contactId];
//   //   //     return related && normalize(related.campaignName) === normalizedFilter;
//   //   //   });

//   //   //   const refundContactIds = new Set(
//   //   //     data.map((item) => item.contactId).filter(Boolean)
//   //   //   );

//   //   //   const filteredMissingTemplates = data1.filter(
//   //   //     (item) =>
//   //   //       normalize(item.campaignName) === normalizedFilter &&
//   //   //       !refundContactIds.has(item.contactId)
//   //   //   );

//   //   //   combinedData = [...filteredRefunds, ...filteredMissingTemplates];
//   //   // }
//   //   //  else {
//   //   //   const refundContactIds = new Set(
//   //   //     data.map((item) => item.contactId).filter(Boolean)
//   //   //   );
//   //   //   const uniqueData1 = data1.filter(
//   //   //     (item) => item.contactId && !refundContactIds.has(item.contactId)
//   //   //   );
//   //   //   combinedData = [...data, ...uniqueData1];
//   //   // }

//   //   // Remove duplicates by order

//   //   if (campaignFilter) {
//   //     const normalizedFilter = normalize(campaignFilter);

//   //     // 1️⃣ Build a map for quick lookup: contactId => campaignName
//   //     const contactIdToCampaign = data1.reduce((acc, item) => {
//   //       if (item.contactId && item.campaignName) {
//   //         acc[item.contactId] = normalize(item.campaignName);
//   //       }
//   //       return acc;
//   //     }, {});

//   //     // 2️⃣ Refund data that belongs to this campaign
//   //     const filteredRefunds = data.filter(
//   //       (refundItem) =>
//   //         contactIdToCampaign[refundItem.contactId] === normalizedFilter
//   //     );

//   //     // 3️⃣ Orders for the same campaign without refund yet
//   //     const refundContactIds = new Set(
//   //       data.map((item) => item.contactId).filter(Boolean)
//   //     );

//   //     const filteredMissingTemplates = data1.filter(
//   //       (orderItem) =>
//   //         normalize(orderItem.campaignName) === normalizedFilter &&
//   //         !refundContactIds.has(orderItem.contactId)
//   //     );

//   //     // 4️⃣ Combine them
//   //     combinedData = [...filteredRefunds, ...filteredMissingTemplates];
//   //   } else {
//   //     // If no campaign filter, show both refunds and non-refund orders
//   //     const refundContactIds = new Set(
//   //       data.map((item) => item.contactId).filter(Boolean)
//   //     );
//   //     const uniqueData1 = data1.filter(
//   //       (item) => item.contactId && !refundContactIds.has(item.contactId)
//   //     );
//   //     combinedData = [...data, ...uniqueData1];
//   //   }



//   //   const uniqueByOrderId = Object.values(
//   //     combinedData.reduce((acc, item) => {
//   //       if (item.order) {
//   //         acc[item.order] = item;
//   //       }
//   //       return acc;
//   //     }, {})
//   //   );

//   //   // Apply additional filters
//   //   let finalData = uniqueByOrderId;

//   //   if (reasonFilter) {
//   //     finalData = finalData.filter((item) =>
//   //       item.reasons
//   //         ? Array.isArray(item.reasons)
//   //           ? item.reasons.includes(reasonFilter)
//   //           : item.reasons === reasonFilter
//   //         : false
//   //     );
//   //   }

//   //   if (statusFilter) {
//   //     finalData = finalData.filter((item) => item.status === statusFilter);
//   //   }

//   //   if (paymentStatusFilter) {
//   //     finalData = finalData.filter(
//   //       (item) => item.paymentStatus === paymentStatusFilter
//   //     );
//   //   }

//   //   // Debug: Log filtered data
//   //   console.log("Filtered Data:", finalData);
//   //   console.log("Applied Campaign Filter:", campaignFilter);

//   //   setFilteredData(finalData);
//   // }, [
//   //   campaignFilter,
//   //   data,
//   //   data1,
//   //   reasonFilter,
//   //   statusFilter,
//   //   paymentStatusFilter,
//   // ]);

//   //working code 
//   // useEffect(() => {
//   //   let combinedData = [];

//   //   const normalize = (str) => str?.trim() || "";

//   //   if (campaignFilter || brandFilter) {
//   //     const normalizedCampaignFilter = normalize(campaignFilter);
//   //     const normalizedBrandFilter = normalize(brandFilter);

//   //     // Build a map for quick lookup: contactId => { campaignName, brandName }
//   //     const contactIdToInfo = data1.reduce((acc, item) => {
//   //       if (item.contactId) {
//   //         acc[item.contactId] = {
//   //           campaignName: normalize(item.campaignName),
//   //           brandName: normalize(item.brandName),
//   //         };
//   //       }
//   //       return acc;
//   //     }, {});

//   //     // Refund data that matches campaign and/or brand
//   //     const filteredRefunds = data.filter((refundItem) => {
//   //       const info = contactIdToInfo[refundItem.contactId] || {};
//   //       const campaignMatch = !campaignFilter || info.campaignName === normalizedCampaignFilter;
//   //       const brandMatch = !brandFilter || info.brandName === normalizedBrandFilter;
//   //       return campaignMatch && brandMatch;
//   //     });


//   //     // Orders for the same campaign/brand without refund yet
//   //     const refundContactIds = new Set(
//   //       data.map((item) => item.contactId).filter(Boolean)
//   //     );

//   //     const filteredMissingTemplates = data1.filter(
//   //       (orderItem) => {
//   //         const campaignMatch = !campaignFilter || normalize(orderItem.campaignName) === normalizedCampaignFilter;
//   //         const brandMatch = !brandFilter || normalize(orderItem.brandName) === normalizedBrandFilter;
//   //         return campaignMatch && brandMatch && !refundContactIds.has(orderItem.contactId);
//   //       }
//   //     );

//   //     // Combine them
//   //     combinedData = [...filteredRefunds, ...filteredMissingTemplates];
//   //   } else {
//   //     // If no campaign or brand filter, show both refunds and non-refunded orders
//   //     const refundContactIds = new Set(
//   //       data.map((item) => item.contactId).filter(Boolean)
//   //     );
//   //     const uniqueData1 = data1.filter(
//   //       (item) => item.contactId && !refundContactIds.has(item.contactId)
//   //     );
//   //     combinedData = [...data, ...uniqueData1];
//   //   }

//   //   // Remove duplicates by order
//   //   const uniqueByOrderId = Object.values(
//   //     combinedData.reduce((acc, item) => {
//   //       if (item.order) {
//   //         acc[item.order] = item;
//   //       }
//   //       return acc;
//   //     }, {})
//   //   );

//   //   // Apply additional filters
//   //   let finalData = uniqueByOrderId;

//   //   if (reasonFilter) {
//   //     finalData = finalData.filter((item) =>
//   //       item.reasons
//   //         ? Array.isArray(item.reasons)
//   //           ? item.reasons.includes(reasonFilter)
//   //           : item.reasons === reasonFilter
//   //         : false
//   //     );
//   //   }

//   //   if (statusFilter) {
//   //     finalData = finalData.filter((item) => item.status === statusFilter);
//   //   }

//   //   if (paymentStatusFilter) {
//   //     finalData = finalData.filter(
//   //       (item) => item.paymentStatus === paymentStatusFilter
//   //     );
//   //   }

//   //   // Debug: Log filtered data
//   //   console.log("Filtered Data:", finalData);
//   //   console.log("Applied Campaign Filter:", campaignFilter);
//   //   console.log("Applied Brand Filter:", brandFilter);

//   //   setFilteredData(finalData);
//   // }, [
//   //   campaignFilter,
//   //   brandFilter, // Add brandFilter to dependency array
//   //   data,
//   //   data1,
//   //   reasonFilter,
//   //   statusFilter,
//   //   paymentStatusFilter,
//   // ]);

//   // Action handlers
//   // const handleApprove = async (contactId) => {
//   //   if (!contactId) {
//   //     console.error("Missing contactId for approve action");
//   //     return;
//   //   }
//   //   try {
//   //     await axios.post(`${Config.API_URL}/api/approve-payment`, { contactId });
//   //     setData((prev) =>
//   //       prev.map((item) =>
//   //         item.contactId === contactId ? { ...item, status: "Approved" } : item
//   //       )
//   //     );
//   //     setData1((prev) =>
//   //       prev.map((item) =>
//   //         item.contactId === contactId ? { ...item, status: "Approved" } : item
//   //       )
//   //     );
//   //     setFilteredData((prev) =>
//   //       prev.map((item) =>
//   //         item.contactId === contactId ? { ...item, status: "Approved" } : item
//   //       )
//   //     );
//   //   } catch (error) {
//   //     console.error("Error approving contactId:", error);
//   //   }
//   // };
//   useEffect(() => {
//     const normalize = (str) => (str ? str.trim().toLowerCase() : "");

//     let combinedData = [];

//     if (campaignFilter || brandFilter) {
//       const normalizedCampaignFilter = normalize(campaignFilter);
//       const normalizedBrandFilter = normalize(brandFilter);

//       const contactIdToInfo = data1.reduce((acc, item) => {
//         if (item.contactId && item.campaignName) {
//           acc[item.contactId] = {
//             campaignName: normalize(item.campaignName),
//             brandName: normalize(item.brandName || ""),
//             paymentStatus: normalize(item.paymentStatus || "pending"),
//           };
//         }
//         return acc;
//       }, {});

//       const filteredRefunds = data.filter((refundItem) => {
//         if (!refundItem.contactId) {
//           console.log("Skipping refundItem with no contactId:", refundItem);
//           return false;
//         }
//         const info = contactIdToInfo[refundItem.contactId];
//         if (!info) {
//           console.log(
//             "Skipping refundItem with no matching contactId in data1:",
//             refundItem
//           );
//           return false;
//         }
//         const campaignMatch =
//           !campaignFilter || info.campaignName === normalizedCampaignFilter;
//         const brandMatch =
//           !brandFilter || info.brandName === normalizedBrandFilter;
//         return campaignMatch && brandMatch;
//       });

//       const refundContactIds = new Set(
//         data.map((item) => item.contactId).filter(Boolean)
//       );

//       const filteredMissingTemplates = data1.filter((orderItem) => {
//         if (!orderItem.campaignName) {
//           console.log("Skipping orderItem with no campaignName:", orderItem);
//           return false;
//         }
//         const campaignMatch =
//           !campaignFilter ||
//           normalize(orderItem.campaignName) === normalizedCampaignFilter;
//         const brandMatch =
//           !brandFilter ||
//           normalize(orderItem.brandName || "") === normalizedBrandFilter;
//         const isNotRefunded =
//           orderItem.contactId && !refundContactIds.has(orderItem.contactId);
//         return campaignMatch && brandMatch && isNotRefunded;
//       });

//       combinedData = [...filteredRefunds, ...filteredMissingTemplates].map(
//         (item) => ({
//           ...item,
//           paymentStatus: normalize(
//             item.paymentStatus ||
//             contactIdToInfo[item.contactId]?.paymentStatus ||
//             "pending"
//           ),
//         })
//       );
//     } else {
//       const refundContactIds = new Set(
//         data.map((item) => item.contactId).filter(Boolean)
//       );
//       const uniqueData1 = data1.filter(
//         (item) => item.contactId && !refundContactIds.has(item.contactId)
//       );
//       combinedData = [...data, ...uniqueData1].map((item) => ({
//         ...item,
//         paymentStatus: normalize(item.paymentStatus || "pending"),
//       }));
//     }

//     const uniqueByOrderId = Object.values(
//       combinedData.reduce((acc, item) => {
//         if (item.order) {
//           acc[item.order] = item;
//         }
//         return acc;
//       }, {})
//     );

//     let finalData = uniqueByOrderId;

//     if (reasonFilter) {
//       finalData = finalData.filter((item) =>
//         item.reasons
//           ? Array.isArray(item.reasons)
//             ? item.reasons.includes(reasonFilter)
//             : item.reasons === reasonFilter
//           : false
//       );
//     }

//     if (statusFilter) {
//       finalData = finalData.filter((item) => item.status === statusFilter);
//     }

//     // Allow all payment statuses if no filter is selected
//     if (paymentStatusFilter) {
//       finalData = finalData.filter(
//         (item) =>
//           normalize(item.paymentStatus) === normalize(paymentStatusFilter)
//       );
//     }

//     console.log("Final Filtered Data:", finalData);
//     console.log(
//       "Payment Statuses in finalData:",
//       finalData.map((item) => item.paymentStatus)
//     );
//     console.log("Applied Filters:", {
//       campaignFilter,
//       brandFilter,
//       statusFilter,
//       paymentStatusFilter,
//     });

//     setFilteredData([...finalData]);
//   }, [
//     campaignFilter,
//     brandFilter,
//     data,
//     data1,
//     reasonFilter,
//     statusFilter,
//     paymentStatusFilter,
//   ]);
//   const handleApprove = async (contactId) => {
//     if (!contactId) {
//       console.error("Missing contactId for approve action");
//       return;
//     }
//     try {
//       console.log("API URL:", Config.API_URL);
//       console.log("Approving contactId:", contactId);
//       await axios.post(`${Config.API_URL}/api/approve-payment`, { contactId });
//       setData((prev) => {
//         const updated = prev.map((item) =>
//           item.contactId === contactId ? { ...item, status: "Approved" } : item
//         );
//         console.log("Updated data:", updated);
//         return updated;
//       });
//       setData1((prev) => {
//         const updated = prev.map((item) =>
//           item.contactId === contactId ? { ...item, status: "Approved" } : item
//         );
//         console.log("Updated data1:", updated);
//         return updated;
//       });
//       setFilteredData((prev) => {
//         const updated = prev.map((item) =>
//           item.contactId === contactId ? { ...item, status: "Approved" } : item
//         );
//         console.log("Updated filteredData:", updated);
//         return updated;
//       });
//       alert("Payment approved successfully!");
//     } catch (error) {
//       console.error("Error approving contactId:", error);
//       if (error.response?.status === 404) {
//         alert("Approval endpoint not found. Please contact the administrator.");
//       } else {
//         alert("Failed to approve payment. Please try again.");
//       }
//     }
//   };
//   const handleOnHold = async (contactId) => {
//     if (!contactId) {
//       console.error("Missing contactId for on-hold action");
//       return;
//     }
//     try {
//       // TODO: Verify endpoint with backend
//       await axios.post(`${Config.API_URL}/api/on-hold-payment`, { contactId });
//       setData((prev) =>
//         prev.map((item) =>
//           item.contactId === contactId ? { ...item, status: "On-hold" } : item
//         )
//       );
//       setData1((prev) =>
//         prev.map((item) =>
//           item.contactId === contactId ? { ...item, status: "On-hold" } : item
//         )
//       );
//       setFilteredData((prev) =>
//         prev.map((item) =>
//           item.contactId === contactId ? { ...item, status: "On-hold" } : item
//         )
//       );
//     } catch (error) {
//       console.error("Error putting on hold contactId:", error);
//     }
//   };

//   const openRejectModal = (item) => {
//     setSelectedItem(item);
//     setSelectedReasons([]);
//     setCustomReason("");
//     setShowModal(true);
//   };

//   const closeRejectModal = () => {
//     setShowModal(false);
//     setSelectedItem(null);
//     setCustomReason("");
//     setSelectedReasons([]);
//   };

//   const toggleReason = (reason) => {
//     setSelectedReasons((prev) =>
//       prev.includes(reason)
//         ? prev.filter((r) => r !== reason)
//         : [...prev, reason]
//     );
//   };

//   const handleSubmitRejection = async () => {
//     if (!selectedItem) return;

//     const orderId = selectedItem.orderId || selectedItem.order;
//     if (!orderId) {
//       console.error("Missing orderId or order in selectedItem", selectedItem);
//       return;
//     }

//     const finalReasons = selectedReasons.includes("Others")
//       ? [...selectedReasons.filter((r) => r !== "Others"), customReason]
//       : selectedReasons;

//     try {
//       await axios.post(`${Config.API_URL}/api/reject-payment`, {
//         orderId,
//         reasons: finalReasons,
//       });

//       setData((prev) =>
//         prev.map((item) =>
//           item.orderId === orderId
//             ? { ...item, status: "Canceled", reasons: finalReasons }
//             : item
//         )
//       );

//       setData1((prev) =>
//         prev.map((item) =>
//           item.orderId === orderId
//             ? { ...item, status: "Canceled", reasons: finalReasons }
//             : item
//         )
//       );

//       setFilteredData((prev) =>
//         prev.map((item) =>
//           item.orderId === orderId
//             ? { ...item, status: "Canceled", reasons: finalReasons }
//             : item
//         )
//       );
//     } catch (error) {
//       console.error("Error canceling order:", error);
//     }

//     closeRejectModal();
//   };

//   // Sorting handler
//   const handleSortByDate = () => {
//     const newSortOrder = sortOrder === "asc" ? "desc" : "asc";
//     const sorted = [...filteredData].sort((a, b) => {
//       const dateA = data1.find((d) => d.order === a.order)?.date;
//       const dateB = data1.find((d) => d.order === b.order)?.date;
//       const parsedDateA = dateA ? new Date(dateA) : new Date(0);
//       const parsedDateB = dateB ? new Date(dateB) : new Date(0);
//       return newSortOrder === "asc"
//         ? parsedDateA - parsedDateB
//         : parsedDateB - parsedDateA;
//     });

//     setFilteredData(sorted);
//     setSortOrder(newSortOrder);
//   };

//   // Download CSV function
//   const downloadCSV = (dataToDownload, filename) => {
//     const csvHeaders = [
//       "Campaign Name",
//       "User Name",
//       "Order ID",
//       "Quantity",
//       "Invoice Number",
//       "Product Amount",
//       "Deliverable Link",
//       "Bank Name",
//       "Ifsc",
//       "Beneficiary Name",
//       "Account Number",
//       "UPI Number",
//       "Managers",
//       "Date",
//       "Student",
//       "College",
//       "Whatsapp Group",
//       "Pin Code",
//       "City",
//       "Product Name",
//       "Order Delivered Screen Shot",
//       "Submitting Rating SS",
//       "Full Name",
//       "Facebook",
//       "Twitter",
//       "YouTube",
//       "Custom Social",
//       "Gender",
//       "Whatsapp",
//       "Phone",
//       "Custom MarketPlace",
//       "Custom Review",
//       "Custom Profile Link",
//       "Email",
//       "Status",
//       "Payment Status",
//     ];

//     const csvRows = dataToDownload.map((item) => {
//       const matchedData = data1.find((d) => d.order === item.order);
//       return [
//         matchedData?.campaignName || "",
//         matchedData?.brandName || "", // Added Brand 
//         matchedData?.AuthInstagram || "",
//         item.order || "",
//         item.quantity || "",
//         item.inputValue1 || "",
//         matchedData?.productAmount || "",
//         item.inputValue2 || "",
//         matchedData?.BankName || "",
//         item.ifsc || "",
//         item.BeneficiaryName || "",
//         item.accountNumber || "",
//         item.UPI || "",
//         Array.isArray(matchedData?.managers)
//           ? matchedData.managers.join(", ")
//           : "",
//         matchedData?.date || "",
//         String(matchedData?.student) === "true" ? "Yes" : "No",
//         matchedData?.collegeName || "",
//         item.whatsappGroup || "",
//         matchedData?.pinCode || "",
//         matchedData?.city || "",
//         item.inputValue || "",
//         item.inputValue3 ? `${Config.API_URL}/${item.inputValue3}` : "",
//         item.inputValue4 ? `${Config.API_URL}/${item.inputValue4}` : "",
//         matchedData?.FullName || "",
//         matchedData?.AuthFacebook || "",
//         matchedData?.AuthTwitter || "",
//         matchedData?.AuthYouTube || "",
//         matchedData?.AuthCustomSocial || "",
//         matchedData?.gender || "",
//         matchedData?.whatsapp || "",
//         matchedData?.Phone || "",
//         matchedData?.customMarketPlaceName || "",
//         matchedData?.review || "",
//         matchedData?.customForum || "",
//         matchedData?.email || "",
//         item.status || "Pending Approval",
//         item.paymentStatus || "",
//       ].map((field) => `"${String(field).replace(/"/g, '""')}"`);
//     });

//     const csvContent = [
//       csvHeaders.join(","),
//       ...csvRows.map((row) => row.join(",")),
//     ].join("\n");
//     const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
//     const url = URL.createObjectURL(blob);
//     const link = document.createElement("a");
//     link.href = url;
//     link.download = filename;
//     link.click();
//     URL.revokeObjectURL(url);
//   };

//   // Status and reason options
//   const statusOptions = ["Failed", "Processed", "Queue"];
//   const approve = ["Pending Approval", "Approved", "Canceled", "On-hold"];
//   const reason = [
//     "Everything is Okay",
//     "Missing Item(s): Order Screenshot",
//     "Missing Item(s): Delivered Screenshot",
//     "Missing Item(s): Review / Rating Screenshot",
//     "Missing Item(s): Live Review Screenshot",
//     "Missing Item(s): Invoice",
//     "Missing Item(s): Live Review Link",
//     "Mismatched Details: Of Order ID",
//     "Mismatched Details: Of Product ID",
//     "Mismatched Details: Of Product Amount",
//     "Mismatched Details: Of Order Date",
//     "Mismatched Details: Of Product",
//     "Mismatched Details: Of Order Screenshot",
//     "Mismatched Details: Of Review Screenshot and Live Review",
//     "Mismatched Details: Of Reviewer Name",
//     "Suspicious Activity: In Order Screenshot",
//     "Suspicious Activity: In Delivered Screenshot",
//     "Suspicious Activity: In the Submitted Review / Rating Screenshot",
//     "Suspicious Activity: In the Live Review Screenshot",
//     "Suspicious Activity: In Live Review Screenshot(Review not verified)",
//     "Suspicious Activity: In Invoice(PDF / Screenshot)",
//     "Suspicious Activity: In Order Status(Product returned)",
//     "Suspicious Activity: In Order Status(Order canceled)",
//     "Suspicious Activity: In Order Status(Order not delivered yet)",
//     "Wrong Documents / Details Submitted: Order Screenshot",
//     "Wrong Documents / Details Submitted: Delivered Screenshot",
//     "Wrong Documents / Details Submitted: Review / Rating Screenshot",
//     "Wrong Documents / Details Submitted: Live Review Screenshot",
//     "Wrong Documents / Details Submitted: Invoice",
//     "Wrong Documents / Details Submitted: Live Review Link",
//     "Wrong Documents / Details Submitted, Live Review Screenshot(Not from logged in account)",
//     "Review Quality: Only Rating(No review)",
//     "Review Quality: Only Rating Required No review needed)",
//     "Review Quality: Very Short Review",
//     "Review Quality: Incorrect Rating",
//     "Review Quality: Review with Title Only(No Description)",
//     "Review Quality: Missing Video",
//     "Review Quality: Missing Image",
//     "Review Quality: Missing Keywords",
//     "Review Quality: Wrong Gender",
//     "Screenshot Quality(Resolution) is bad: Order Screenshot",
//     "Screenshot Quality(Resolution) is bad: Delivered Screenshot",
//     "Screenshot Quality(Resolution) is bad: Review / Rating Screenshot",
//     "Screenshot Quality(Resolution) is bad: Live Review Screenshot",
//     "Screenshot Quality(Resolution) is bad: Invoice",
//     "Screenshot Completeness(Not Full Page): Order Screenshot",
//     "Screenshot Completeness(Not Full Page): Delivered Screenshot",
//     "Screenshot Completeness(Not Full Page): Review / Rating Screenshot",
//     "Screenshot Completeness(Not Full Page): Live Review Screenshot",
//     "Screenshot Completeness(Not Full Page): Invoice Duplicate",
//     "Shipping Fee Issue: Shipping fee exceeds the limit of the standard fee",
//   ];

//   // Mouse drag scrolling
//   let isDown = false;
//   let startX;
//   let scrollLeft;

//   const handleMouseDown = (e) => {
//     const slider = e.currentTarget;
//     isDown = true;
//     slider.classList.add("active");
//     startX = e.pageX - slider.offsetLeft;
//     scrollLeft = slider.scrollLeft;
//   };

//   const handleMouseLeave = (e) => {
//     isDown = false;
//     e.currentTarget.classList.remove("active");
//   };

//   const handleMouseUp = (e) => {
//     isDown = false;
//     e.currentTarget.classList.remove("active");
//   };

//   const handleMouseMove = (e) => {
//     if (!isDown) return;
//     e.preventDefault();
//     const slider = e.currentTarget;
//     const x = e.pageX - slider.offsetLeft;
//     const walk = (x - startX) * 2;
//     slider.scrollLeft = scrollLeft - walk;
//   };

//   return (
//     <div className="table-component container mt-5">
//       <style>
//         {`
//           .table-component .table-container {
//             max-width: 100%;
//             overflow-x: auto;
//             cursor: grab;
//           }
//           .table-component .table-container.active {
//             cursor: grabbing;
//           }
//           .table-component .table {
//             width: 100%;
//             border-collapse: collapse;
//           }
//           .table-component .table th,
//           .table-component .table td {
//             padding: 8px;
//             border: 1px solid #ddd;
//             text-align: left;
//           }
//           .table-component .table th {
//             background-color: #808080;
//             cursor: pointer;
//           }
//           .table-component .table th.customStyle:hover {
//             background-color: #e0e0e0;
//           }
//           .table-component .dropdown {
//             padding: 5px;
//             margin-left: 10px;
//             border-radius: 4px;
//             border: 1px solid #ccc;
//           }
//           .table-component .filters {
//             display: flex;
//             align-items: center;
//             margin-bottom: 15px;
//           }
//           .table-component .button {
//             padding: 8px 12px;
//             border: none;
//             border-radius: 4px;
//             cursor: pointer;
//             margin-right: 10px;
//           }
//           .table-component .button.is-primary {
//             background-color: #3273dc;
//             color: white;
//           }
//           .table-component .button.is-primary.is-light {
//             background-color: #eff1fa;
//             color: #3273dc;
//           }
//           .table-component .button.is-danger {
//             background-color: #ff3860;
//             color: white;
//           }
//           .table-component .button.is-danger.is-light {
//             background-color: #ffecf0;
//             color: #ff3860;
//           }
//           .table-component .button.is-warning {
//             background-color: #ffdd57;
//             color: #333;
//           }
//           .table-component .button.is-warning.is-light {
//             background-color: #fff5cc;
//             color: #333;
//           }
//           .table-component .button.is-info {
//             background-color: #209cee;
//             color: white;
//           }
//           .table-component .button:disabled {
//             opacity: 0.5;
//             cursor: not-allowed;
//           }
//         `}
//       </style>

//       {/* Download Buttons and Reset Filters */}
//       <div className="mb-3">
//         <button
//           className="button is-info"
//           onClick={() => downloadCSV(filteredData, "filtered_data.csv")}
//           disabled={loading}
//         >
//           Download Filtered Data as CSV
//         </button>
//         <button
//           className="button is-info"
//           onClick={() => {
//             const refundContactIds = new Set(
//               data.map((item) => item.contactId).filter(Boolean)
//             );
//             const uniqueData1 = data1.filter(
//               (item) => item.contactId && !refundContactIds.has(item.contactId)
//             );
//             const allData = [...data, ...uniqueData1];
//             const uniqueAll = Object.values(
//               allData.reduce((acc, item) => {
//                 if (item.order) acc[item.order] = item;
//                 return acc;
//               }, {})
//             );
//             downloadCSV(uniqueAll, "all_data.csv");
//           }}
//           disabled={loading}
//         >
//           Download All Data as CSV
//         </button>
//         <button className="button is-warning" onClick={handleResetFilters}>
//           Reset Filters
//         </button>
//       </div>

//       {/* Loading State */}
//       {loading && <p>Loading data...</p>}

//       {/* Filters */}
//       {!loading && (
//         <>
//           <div className="filters">
//             <label htmlFor="campaignFilter" className="mr-2">
//               Filter by Campaign:
//             </label>
//             <select
//               id="campaignFilter"
//               value={campaignFilter}
//               onChange={handleCampaignChange}
//               className="dropdown"
//             >
//               <option value="">All Campaigns</option>
//               {campaigns.map((campaign, index) => (
//                 <option key={index} value={campaign}>
//                   {campaign}
//                 </option>
//               ))}
//             </select>
//           </div>
//           <div className="filters">
//             <label htmlFor="brandFilter" className="mr-2">
//               Filter by Brand:
//             </label>
//             <select
//               id="brandFilter"
//               value={brandFilter}
//               onChange={handleBrandChange}
//               className="dropdown"
//             >
//               <option value="">All Brands</option>
//               {brands.map((brand, index) => (
//                 <option key={index} value={brand}>
//                   {brand}
//                 </option>
//               ))}
//             </select>
//           </div>
//           <div className="filters">
//             <label htmlFor="reasonFilter" className="mr-2">
//               Filter by Reason:
//             </label>
//             <select
//               id="reasonFilter"
//               value={reasonFilter}
//               onChange={handlereasonChange}
//               className="dropdown"
//             >
//               <option value="">All Reasons</option>
//               {reason.map((reason, index) => (
//                 <option key={index} value={reason}>
//                   {reason}
//                 </option>
//               ))}
//             </select>
//           </div>
//           <div className="filters">
//             <label htmlFor="statusFilter" className="mr-2">
//               Filter by Application Status:
//             </label>
//             <select
//               id="statusFilter"
//               value={statusFilter}
//               onChange={handlestatusChange}
//               className="dropdown"
//             >
//               <option value="">All Statuses</option>
//               {approve.map((status, index) => (
//                 <option key={index} value={status}>
//                   {status}
//                 </option>
//               ))}
//             </select>
//           </div>
//           <div className="filters">
//             <label htmlFor="paymentStatusFilter" className="mr-2">
//               Filter by Payment Status:
//             </label>
//             <select
//               id="paymentStatusFilter"
//               value={paymentStatusFilter}
//               onChange={handlePaymentStatusChange}
//               className="dropdown"
//             >
//               <option value="">All Payment Statuses</option>
//               {statusOptions.map((status, index) => (
//                 <option key={index} value={status}>
//                   {status}
//                 </option>
//               ))}
//             </select>
//           </div>
//         </>
//       )}

//       {/* Table */}
//       {!loading && (
//         <div
//           className="table-container"
//           onMouseDown={handleMouseDown}
//           onMouseLeave={handleMouseLeave}
//           onMouseUp={handleMouseUp}
//           onMouseMove={handleMouseMove}
//         >
//           <table className="table">
//             <thead>
//               <tr>
//                 <th className="customStyle">Campaign Name</th>
//                 <th className="customStyle">Brand Name</th>
//                 <th className="customStyle">User Name</th>
//                 <th className="customStyle">Order ID</th>
//                 <th className="customStyle">Quantity</th>
//                 <th className="customStyle">Invoice Number</th>
//                 <th className="customStyle">Product Amount</th>
//                 <th className="customStyle">Deliverable Link</th>
//                 <th className="customStyle">Bank Name</th>
//                 <th className="customStyle">Ifsc</th>
//                 <th className="customStyle">Beneficiary Name</th>
//                 <th className="customStyle">Account Number</th>
//                 <th className="customStyle">UPI Number</th>
//                 <th className="customStyle">Managers</th>
//                 <th className="customStyle" onClick={handleSortByDate}>
//                   Date {sortOrder === "asc" ? "↑" : "↓"}
//                 </th>
//                 <th className="customStyle">Student</th>
//                 <th className="customStyle">College</th>
//                 <th className="customStyle">Whatsapp Group</th>
//                 <th className="customStyle">Pin Code</th>
//                 <th className="customStyle">City</th>
//                 <th className="customStyle">Product Name</th>
//                 <th className="customStyle">Order Delivered Screen Shot</th>
//                 <th className="customStyle">Submitting Rating SS</th>
//                 <th className="customStyle">Seller Feedback Screenshot </th>
//                 <th className="customStyle">Invoice Pdf </th>
//                 <th className="customStyle">Full Name</th>
//                 <th className="customStyle">Facebook</th>
//                 <th className="customStyle">Twitter</th>
//                 <th className="customStyle">YouTube</th>
//                 {/* <th className="customStyle">Custom Social</th> */}
//                 <th className="customStyle">Gender</th>
//                 <th className="customStyle">Whatsapp</th>
//                 <th className="customStyle">Phone</th>
//                 <th className="customStyle">Custom MarketPlace</th>
//                 <th className="customStyle">Custom Review</th>
//                 {/* <th className="customStyle">Custom Profile Link</th> */}
//                 <th className="customStyle">Email</th>
//                 <th className="customStyle">Actions</th>
//                 <th className="customStyle">Status</th>
//                 <th className="customStyle">Payment Status</th>
//               </tr>
//             </thead>
//             <tbody>
//               {filteredData.length > 0 ? (
//                 filteredData.map((item, index) => {
//                   const matchedData = data1.find((d) => d.order === item.order);
//                   return (
//                     <tr key={index}>
//                       <td className="customStyle">
//                         {matchedData?.campaignName || ""}
//                       </td>
//                       <td className="customStyle">
//                         {matchedData?.brandName || ""}
//                       </td>
//                       <td className="customStyle">
//                         {matchedData?.AuthInstagram ? (
//                           <a
//                             href={`https://www.instagram.com/${matchedData.AuthInstagram}`}
//                             target="_blank"
//                             rel="noopener noreferrer"
//                             style={{
//                               color: "blue",
//                               textDecoration: "underline",
//                             }}
//                           >
//                             {matchedData.AuthInstagram}
//                           </a>
//                         ) : (
//                           ""
//                         )}
//                       </td>
//                       <td className="customStyle">{item.order || ""}</td>
//                       <td className="customStyle">{matchedData?.quantity || ""}</td>
//                       <td className="customStyle">{item.invoiceNumber || ""}</td>
//                       <td className="customStyle">
//                         {matchedData?.productAmount || ""}
//                       </td>
//                       <td className="customStyle">{item.inputValue2 || ""}</td>
//                       <td className="customStyle">
//                         {matchedData?.BankName || ""}
//                       </td>
//                       <td className="customStyle">{item.ifsc || ""}</td>
//                       <td className="customStyle">
//                         {item.beneficiaryName || ""}
//                       </td>
//                       <td className="customStyle">
//                         {item.accountNumber || ""}
//                       </td>
//                       <td className="customStyle">{item.UPI || ""}</td>
//                       <td className="customStyle">
//                         {Array.isArray(matchedData?.managers)
//                           ? matchedData.managers.join(", ")
//                           : ""}
//                       </td>
//                       <td className="customStyle">{matchedData?.date || ""}</td>
//                       <td className="customStyle">
//                         {String(matchedData?.student) === "true" ? "Yes" : "No"}
//                       </td>
//                       <td className="customStyle">
//                         {matchedData?.collegeName || ""}
//                       </td>
//                       <td className="customStyle">
//                         {item.whatsappGroup || ""}
//                       </td>
//                       <td className="customStyle">
//                         {matchedData?.pinCode || ""}
//                       </td>
//                       <td className="customStyle">{matchedData?.city || ""}</td>
//                       <td className="customStyle">{matchedData?.productName || ""}</td>
//                       <td className="customStyle">
//                         {item.inputValue3 && (
//                           <a
//                             href={`${Config.API_URL}/${item.inputValue3}`}
//                             target="_blank"
//                             rel="noopener noreferrer"
//                           >
//                             <img
//                               src={`${Config.API_URL}/${item.inputValue3}`}
//                               alt="Order Screenshot"
//                               style={{ width: "100px", height: "auto" }}
//                             />
//                           </a>
//                         )}
//                       </td>
//                       <td className="customStyle">
//                         {item.inputValue4 && (
//                           <a
//                             href={`${Config.API_URL}/${item.inputValue4}`}
//                             target="_blank"
//                             rel="noopener noreferrer"
//                           >
//                             <img
//                               src={`${Config.API_URL}/${item.inputValue4}`}
//                               alt="Rating Screenshot"
//                               style={{ width: "100px", height: "auto" }}
//                             />
//                           </a>
//                         )}
//                       </td>
//                       <td className="customStyle">
//                         {item.sellarFeedbackScreenshot && (
//                           <a href={`${Config.API_URL}/${item.sellarFeedbackScreenshot}`} target="_blank" rel="noopener noreferrer">
//                             <img
//                               src={`${Config.API_URL}/${item.sellarFeedbackScreenshot}`}
//                               alt="Screenshot 2"
//                               style={{ width: '100px', height: 'auto' }}
//                             />
//                           </a>
//                         )}
//                       </td>

//                       <td className="customStyle">
//                         {item.invoiceReceived && (
//                           <a href={`${Config.API_URL}/${item.invoiceReceived}`} target="_blank" rel="noopener noreferrer">
//                             <img
//                               src={`${Config.API_URL}/${item.invoiceReceived}`}
//                               alt="Screenshot 2"
//                               style={{ width: '100px', height: 'auto' }}
//                             />
//                           </a>
//                         )}
//                       </td>

//                       <td className="customStyle">
//                         {matchedData?.FullName || ""}
//                       </td>
//                       <td className="customStyle">
//                         {matchedData?.AuthFacebook ? (
//                           <a
//                             href={`https://www.facebook.com/${matchedData.AuthFacebook}`}
//                             target="_blank"
//                             rel="noopener noreferrer"
//                             style={{
//                               color: "blue",
//                               textDecoration: "underline",
//                             }}
//                           >
//                             {matchedData.AuthFacebook}
//                           </a>
//                         ) : (
//                           ""
//                         )}
//                       </td>
//                       <td className="customStyle">
//                         {matchedData?.AuthTwitter ? (
//                           <a
//                             href={`https://www.x.com/${matchedData.AuthTwitter}`}
//                             target="_blank"
//                             rel="noopener noreferrer"
//                             style={{
//                               color: "blue",
//                               textDecoration: "underline",
//                             }}
//                           >
//                             {matchedData.AuthTwitter}
//                           </a>
//                         ) : (
//                           ""
//                         )}
//                       </td>
//                       <td className="customStyle">
//                         {matchedData?.AuthYouTube ? (
//                           <a
//                             href={`https://www.youtube.com/${matchedData.AuthYouTube}`}
//                             target="_blank"
//                             rel="noopener noreferrer"
//                             style={{
//                               color: "blue",
//                               textDecoration: "underline",
//                             }}
//                           >
//                             {matchedData.AuthYouTube}
//                           </a>
//                         ) : (
//                           ""
//                         )}
//                       </td>
//                       {/* <td className="customStyle">
//                         {item?.AuthCustomSocial || ""}
//                       </td> */}
//                       <td className="customStyle">
//                         {matchedData?.gender || ""}
//                       </td>
//                       <td className="customStyle">
//                         {matchedData?.whatsapp || ""}
//                       </td>
//                       <td className="customStyle">
//                         {matchedData?.Phone || ""}
//                       </td>
//                       <td className="customStyle">
//                         {matchedData?.customMarketPlaceName || ""}
//                       </td>
//                       <td className="customStyle">
//                         {matchedData?.review || ""}
//                       </td>
//                       {/* <td className="customStyle">
//                         {matchedData?.customForum || ""}
//                       </td> */}
//                       <td className="customStyle">
//                         {matchedData?.email || ""}
//                       </td>
//                       <td className="customStyle">
//                         <button
//                           onClick={() => handleApprove(item.contactId)}
//                           disabled={item.status === "Approved"}
//                           className={`button is-primary ${item.status === "Approved" ? "is-light" : ""
//                             }`}
//                         >
//                           Approve
//                         </button>
//                         <button
//                           onClick={() => openRejectModal(item)}
//                           disabled={
//                             item.status !== "On-hold" &&
//                             item.status !== "Pending Approval"
//                           }
//                           className={`button is-danger ${item.status === "Canceled" ? "is-light" : ""
//                             }`}
//                         >
//                           Cancel
//                         </button>
//                         <button
//                           onClick={() => handleOnHold(item.contactId)}
//                           disabled={
//                             item.status !== "Canceled" &&
//                             item.status !== "Pending Approval"
//                           }
//                           className={`button is-warning ${item.status === "On-hold" ? "is-light" : ""
//                             }`}
//                         >
//                           On-hold
//                         </button>
//                       </td>
//                       <td className="customStyle">
//                         {item.status === "Canceled" ? (
//                           <>
//                             <strong>Rejected</strong>
//                             {item.reasons?.length > 0 && (
//                               <ul
//                                 style={{
//                                   marginTop: "4px",
//                                   paddingLeft: "16px",
//                                   color: "red",
//                                   fontSize: "12px",
//                                 }}
//                               >
//                                 {item.reasons.map((reason, index) => (
//                                   <li key={index}>- {reason}</li>
//                                 ))}
//                               </ul>
//                             )}
//                           </>
//                         ) : (
//                           <strong>{item.status || "Pending Approval"}</strong>
//                         )}
//                       </td>
//                       <td className="customStyle">
//                         {item.paymentStatus || ""}
//                       </td>
//                     </tr>
//                   );
//                 })
//               ) : (
//                 <tr>
//                   <td colSpan="35">No data available</td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//           <RejectModal
//             isOpen={showModal}
//             onClose={closeRejectModal}
//             onSubmit={handleSubmitRejection}
//             selectedReasons={selectedReasons}
//             toggleReason={toggleReason}
//             customReason={customReason}
//             setCustomReason={setCustomReason}
//           />
//         </div>
//       )}
//     </div>
//   );
// };

// export default Table;

//working code 
import React, { useState, useEffect } from "react";
import axios from "axios";
import { Config } from "../.env.js";
import { useLocation } from "react-router-dom";
import RejectModal from "./resonModal.js"; // TODO: Rename to reasonModal.js if needed

const Table = () => {
  const [data, setData] = useState([]);
  const [data1, setData1] = useState([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const [campaignFilter, setCampaignFilter] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [campaigns, setCampaigns] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedReasons, setSelectedReasons] = useState([]);
  const [customReason, setCustomReason] = useState("");
  const [reasonFilter, setReasonFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [paymentStatusFilter, setPaymentStatusFilter] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");
  const [brandFilter, setBrandFilter] = useState("");
  const [brands, setBrands] = useState([]);

  const campaignName = location.state?.campaignName; // Kept but unused

  // Fetch refund data
  // useEffect(() => {
  //   const fetchRefundData = async () => {
  //     try {
  //       setLoading(true);
  //       const response = await axios.get(`${Config.API_URL}/api/refund`);
  //       setData(response.data);
  //       // console.log("Data:", response.data);
  //       console.log("Refund Data:", response.data);
  //       console.log("Refund Payment Statuses:", response.data.map(item => item.paymentStatus));
  //     } catch (error) {
  //       console.error("Error fetching refund data:", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   fetchRefundData();
  // }, []);
  useEffect(() => {
    const fetchRefundData = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${Config.API_URL}/api/refund`);
        const normalizedData = response.data.map((item) => ({
          ...item,
          status: item.status || "Pending Approval", // Default status
        }));
        setData(normalizedData);
        console.log("Refund Data:", normalizedData);
      } catch (error) {
        console.error("Error fetching refund data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchRefundData();
  }, []);
  useEffect(() => {
    const fetchData1 = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${Config.API_URL}/api/refund-order`);
        setData1(response.data);
        console.log("Data1:", response.data);
        // Normalize campaign names (trim for consistency)
        const uniqueCampaigns = [
          ...new Set(
            response.data
              .filter((item) => item.campaignName) // Ensure campaignName exists
              .map((item) => item.campaignName.trim())
          ),
        ];
        // Normalize brand names (trim for consistency)
        const uniqueBrands = [
          ...new Set(
            response.data
              .filter((item) => item.brandName) // Ensure brandName exists
              .map((item) => item.brandName.trim())
          ),
        ];
        setCampaigns(uniqueCampaigns);
        setBrands(uniqueBrands); // Set unique brands
        console.log("Refund-Order Data:", response.data);
        console.log(
          "Refund-Order Payment Statuses:",
          response.data.map((item) => item.paymentStatus)
        );
      } catch (error) {
        console.error("Error fetching data1:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData1();
  }, []);
  // Filter handlers
  const handleCampaignChange = (e) => setCampaignFilter(e.target.value);
  const handlereasonChange = (e) => setReasonFilter(e.target.value);
  const handlestatusChange = (e) => setStatusFilter(e.target.value);
  const handleBrandChange = (e) => setBrandFilter(e.target.value);
  const handlePaymentStatusChange = (e) =>
    setPaymentStatusFilter(e.target.value);
  const handleResetFilters = () => {
    setCampaignFilter("");
    setReasonFilter("");
    setStatusFilter("");
    setBrandFilter("");
    setPaymentStatusFilter("");
  };


  // useEffect(() => {
  //   let combinedData = [];

  //   const normalize = (str) => str?.trim() || "";

  //   if (campaignFilter || brandFilter) {
  //     const normalizedCampaignFilter = normalize(campaignFilter);
  //     const normalizedBrandFilter = normalize(brandFilter);

  //     // Build a map for quick lookup: contactId => { campaignName, brandName }
  //     const contactIdToInfo = data1.reduce((acc, item) => {
  //       if (item.contactId) {
  //         acc[item.contactId] = {
  //           campaignName: normalize(item.campaignName),
  //           brandName: normalize(item.brandName),
  //         };
  //       }
  //       return acc;
  //     }, {});

  //     // Refund data that matches campaign and/or brand
  //     const filteredRefunds = data.filter((refundItem) => {
  //       const info = contactIdToInfo[refundItem.contactId] || {};
  //       const campaignMatch =
  //         !campaignFilter || info.campaignName === normalizedCampaignFilter;
  //       const brandMatch =
  //         !brandFilter || info.brandName === normalizedBrandFilter;
  //       return campaignMatch && brandMatch;
  //     });

  //     // Orders for the same campaign/brand without refund yet
  //     const refundContactIds = new Set(
  //       data.map((item) => item.contactId).filter(Boolean)
  //     );

  //     const filteredMissingTemplates = data1.filter((orderItem) => {
  //       const campaignMatch =
  //         !campaignFilter ||
  //         normalize(orderItem.campaignName) === normalizedCampaignFilter;
  //       const brandMatch =
  //         !brandFilter ||
  //         normalize(orderItem.brandName) === normalizedBrandFilter;
  //       return (
  //         campaignMatch &&
  //         brandMatch &&
  //         !refundContactIds.has(orderItem.contactId)
  //       );
  //     });

  //     // Combine them
  //     combinedData = [...filteredRefunds, ...filteredMissingTemplates];
  //   } else {
  //     // If no campaign or brand filter, show both refunds and non-refunded orders
  //     const refundContactIds = new Set(
  //       data.map((item) => item.contactId).filter(Boolean)
  //     );
  //     const uniqueData1 = data1.filter(
  //       (item) => item.contactId && !refundContactIds.has(item.contactId)
  //     );
  //     combinedData = [...data, ...uniqueData1];
  //   }

  //   // Remove duplicates by order
  //   const uniqueByOrderId = Object.values(
  //     combinedData.reduce((acc, item) => {
  //       if (item.order) {
  //         acc[item.order] = item;
  //       }
  //       return acc;
  //     }, {})
  //   );

  //   // Apply additional filters
  //   let finalData = uniqueByOrderId;

  //   if (reasonFilter) {
  //     finalData = finalData.filter((item) =>
  //       item.reasons
  //         ? Array.isArray(item.reasons)
  //           ? item.reasons.includes(reasonFilter)
  //           : item.reasons === reasonFilter
  //         : false
  //     );
  //   }

  //   if (statusFilter) {
  //     finalData = finalData.filter((item) => item.status === statusFilter);
  //   }

  //   if (paymentStatusFilter) {
  //     finalData = finalData.filter(
  //       (item) => item.paymentStatus === paymentStatusFilter
  //     );
  //   }

  //   // Debug: Log filtered data
  //   console.log("Filtered Data:", finalData);
  //   console.log("Applied Campaign Filter:", campaignFilter);
  //   console.log("Applied Brand Filter:", brandFilter);

  //   setFilteredData(finalData);
  // }, [
  //   campaignFilter,
  //   brandFilter, // Add brandFilter to dependency array
  //   data,
  //   data1,
  //   reasonFilter,
  //   statusFilter,
  //   paymentStatusFilter,
  // ]);

  // Action handlers



  // useEffect(() => {
  //   let combinedData = [];

  //   const normalize = (str) => str?.trim() || "";

  //   if (campaignFilter || brandFilter) {
  //     const normalizedCampaignFilter = normalize(campaignFilter);
  //     const normalizedBrandFilter = normalize(brandFilter);

  //     // Build a map for quick lookup: contactId => { campaignName, brandName }
  //     const contactIdToInfo = data1.reduce((acc, item) => {
  //       if (item.contactId && item.campaignName) {
  //         // Only include if campaignName exists
  //         acc[item.contactId] = {
  //           campaignName: normalize(item.campaignName),
  //           brandName: normalize(item.brandName || ""),
  //         };
  //       }
  //       return acc;
  //     }, {});

  //     // Refund data that matches campaign and/or brand
  //     const filteredRefunds = data.filter((refundItem) => {
  //       if (!refundItem.contactId) {
  //         console.log("Skipping refundItem with no contactId:", refundItem);
  //         return false;
  //       }
  //       const info = contactIdToInfo[refundItem.contactId];
  //       if (!info) {
  //         console.log(
  //           "Skipping refundItem with no matching contactId in data1:",
  //           refundItem
  //         );
  //         return false; // Skip if contactId not found in data1
  //       }
  //       const campaignMatch =
  //         !campaignFilter ||
  //         (info.campaignName && info.campaignName === normalizedCampaignFilter);
  //       const brandMatch =
  //         !brandFilter ||
  //         (info.brandName && info.brandName === normalizedBrandFilter);
  //       console.log("Processing refundItem:", {
  //         contactId: refundItem.contactId,
  //         campaignName: info.campaignName,
  //         brandName: info.brandName,
  //         campaignMatch,
  //         brandMatch,
  //       });
  //       return campaignMatch && brandMatch;
  //     });

  //     // Orders for the same campaign/brand without refund yet
  //     const refundContactIds = new Set(
  //       data.map((item) => item.contactId).filter(Boolean)
  //     );

  //     const filteredMissingTemplates = data1.filter((orderItem) => {
  //       if (!orderItem.campaignName) {
  //         console.log("Skipping orderItem with no campaignName:", orderItem);
  //         return false; // Skip if campaignName is missing
  //       }
  //       const campaignMatch =
  //         !campaignFilter ||
  //         normalize(orderItem.campaignName) === normalizedCampaignFilter;
  //       const brandMatch =
  //         !brandFilter ||
  //         normalize(orderItem.brandName || "") === normalizedBrandFilter;
  //       const isNotRefunded =
  //         orderItem.contactId && !refundContactIds.has(orderItem.contactId);
  //       console.log("Processing orderItem:", {
  //         contactId: orderItem.contactId,
  //         campaignName: orderItem.campaignName,
  //         brandName: orderItem.brandName,
  //         campaignMatch,
  //         brandMatch,
  //         isNotRefunded,
  //       });
  //       return campaignMatch && brandMatch && isNotRefunded;
  //     });

  //     // Combine filtered refunds and missing templates
  //     combinedData = [...filteredRefunds, ...filteredMissingTemplates];
  //   } else {
  //     // If no campaign or brand filter, show both refunds and non-refunded orders
  //     const refundContactIds = new Set(
  //       data.map((item) => item.contactId).filter(Boolean)
  //     );
  //     const uniqueData1 = data1.filter(
  //       (item) => item.contactId && !refundContactIds.has(item.contactId)
  //     );
  //     combinedData = [...data, ...uniqueData1];
  //   }

  //   // Remove duplicates by order
  //   const uniqueByOrderId = Object.values(
  //     combinedData.reduce((acc, item) => {
  //       if (item.order) {
  //         acc[item.order] = item; // Keep the last occurrence
  //       }
  //       return acc;
  //     }, {})
  //   );

  //   // Apply additional filters
  //   let finalData = uniqueByOrderId;

  //   if (reasonFilter) {
  //     finalData = finalData.filter((item) =>
  //       item.reasons
  //         ? Array.isArray(item.reasons)
  //           ? item.reasons.includes(reasonFilter)
  //           : item.reasons === reasonFilter
  //         : false
  //     );
  //   }

  //   if (statusFilter) {
  //     finalData = finalData.filter((item) => item.status === statusFilter);
  //   }

  //   if (paymentStatusFilter) {
  //     finalData = finalData.filter(
  //       (item) => item.paymentStatus === paymentStatusFilter
  //     );
  //   }

  //   // Debug: Log filtered data
  //   // console.log("Filtered Refunds:", filteredRefunds);
  //   // console.log("Filtered Missing Templates:", filteredMissingTemplates);
  //   console.log("Combined Data:", combinedData);
  //   console.log("Unique Data:", uniqueByOrderId);
  //   console.log("Final Filtered Data:", finalData);
  //   console.log("Applied Campaign Filter:", campaignFilter);
  //   console.log("Applied Brand Filter:", brandFilter);



  //   console.log(
  //     "Payment Statuses in finalData:",
  //     finalData.map((item) => item.paymentStatus)
  //   );
  //   console.log("Applied Payment Status Filter:", paymentStatusFilter);
  //   // console.log("Final Filtered Data:", finalData);
  //   setFilteredData(finalData);
  // }, [
  //   campaignFilter,
  //   brandFilter,
  //   data,
  //   data1,
  //   reasonFilter,
  //   statusFilter,
  //   paymentStatusFilter,
  // ]);


  // useEffect(() => {
  //   const normalize = (str) => (str ? str.trim().toLowerCase() : "pending"); // Default to "pending" if undefined or null

  //   let combinedData = [];

  //   if (campaignFilter || brandFilter) {
  //     const normalizedCampaignFilter = normalize(campaignFilter);
  //     const normalizedBrandFilter = normalize(brandFilter);

  //     // Build a map for quick lookup: contactId => { campaignName, brandName, paymentStatus }
  //     const contactIdToInfo = data1.reduce((acc, item) => {
  //       if (item.contactId && item.campaignName) {
  //         acc[item.contactId] = {
  //           campaignName: normalize(item.campaignName),
  //           brandName: normalize(item.brandName || ""),
  //           paymentStatus: normalize(item.paymentStatus), // Normalize paymentStatus
  //         };
  //       }
  //       return acc;
  //     }, {});

  //     // Refund data that matches campaign and/or brand
  //     const filteredRefunds = data.filter((refundItem) => {
  //       if (!refundItem.contactId) {
  //         console.log("Skipping refundItem with no contactId:", refundItem);
  //         return false;
  //       }
  //       const info = contactIdToInfo[refundItem.contactId];
  //       if (!info) {
  //         console.log(
  //           "Skipping refundItem with no matching contactId in data1:",
  //           refundItem
  //         );
  //         return false;
  //       }
  //       const campaignMatch =
  //         !campaignFilter || info.campaignName === normalizedCampaignFilter;
  //       const brandMatch =
  //         !brandFilter || info.brandName === normalizedBrandFilter;
  //       return campaignMatch && brandMatch;
  //     });

  //     // Orders for the same campaign/brand without refund yet
  //     const refundContactIds = new Set(
  //       data.map((item) => item.contactId).filter(Boolean)
  //     );

  //     const filteredMissingTemplates = data1.filter((orderItem) => {
  //       if (!orderItem.campaignName) {
  //         console.log("Skipping orderItem with no campaignName:", orderItem);
  //         return false;
  //       }
  //       const campaignMatch =
  //         !campaignFilter ||
  //         normalize(orderItem.campaignName) === normalizedCampaignFilter;
  //       const brandMatch =
  //         !brandFilter ||
  //         normalize(orderItem.brandName || "") === normalizedBrandFilter;
  //       const isNotRefunded =
  //         orderItem.contactId && !refundContactIds.has(orderItem.contactId);
  //       return campaignMatch && brandMatch && isNotRefunded;
  //     });

  //     // Combine filtered refunds and missing templates, ensuring paymentStatus
  //     combinedData = [...filteredRefunds, ...filteredMissingTemplates].map(
  //       (item) => ({
  //         ...item,
  //         paymentStatus: normalize(
  //           item.paymentStatus ||
  //             contactIdToInfo[item.contactId]?.paymentStatus ||
  //             "pending"
  //         ),
  //       })
  //     );
  //   } else {
  //     // If no campaign or brand filter, combine refunds and non-refunded orders
  //     const refundContactIds = new Set(
  //       data.map((item) => item.contactId).filter(Boolean)
  //     );
  //     const uniqueData1 = data1.filter(
  //       (item) => item.contactId && !refundContactIds.has(item.contactId)
  //     );
  //     combinedData = [...data, ...uniqueData1].map((item) => ({
  //       ...item,
  //       paymentStatus: normalize(item.paymentStatus || "pending"),
  //     }));
  //   }

  //   // Remove duplicates by order
  //   const uniqueByOrderId = Object.values(
  //     combinedData.reduce((acc, item) => {
  //       if (item.order) {
  //         acc[item.order] = item;
  //       }
  //       return acc;
  //     }, {})
  //   );

  //   // Apply additional filters
  //   let finalData = uniqueByOrderId;

  //   if (reasonFilter) {
  //     finalData = finalData.filter((item) =>
  //       item.reasons
  //         ? Array.isArray(item.reasons)
  //           ? item.reasons.includes(reasonFilter)
  //           : item.reasons === reasonFilter
  //         : false
  //     );
  //   }

  //   if (statusFilter) {
  //     finalData = finalData.filter((item) => item.status === statusFilter);
  //   }

  //   if (paymentStatusFilter) {
  //     finalData = finalData.filter(
  //       (item) =>
  //         normalize(item.paymentStatus) === normalize(paymentStatusFilter)
  //     );
  //   } else {
  //     // Include all items when no payment status filter is selected
  //     finalData = finalData.filter(
  //       (item) =>
  //         normalize(item.paymentStatus) === "pending" ||
  //         ["failed", "processed", "queue"].includes(
  //           normalize(item.paymentStatus)
  //         )
  //     );
  //   }

  //   // Debug: Log filtered data
  //   console.log(
  //     "Payment Statuses in finalData:",
  //     finalData.map((item) => item.paymentStatus)
  //   );
  //   console.log("Applied Payment Status Filter:", paymentStatusFilter);
  //   console.log("Final Filtered Data:", finalData);

  //   setFilteredData([...finalData]);
  // }, [
  //   campaignFilter,
  //   brandFilter,
  //   data,
  //   data1,
  //   reasonFilter,
  //   statusFilter,
  //   paymentStatusFilter,
  // ]);


  // useEffect(() => {
  //   const normalize = (str) => (str ? str.trim().toLowerCase() : "");

  //   let combinedData = [];

  //   if (campaignFilter || brandFilter) {
  //     const normalizedCampaignFilter = normalize(campaignFilter);
  //     const normalizedBrandFilter = normalize(brandFilter);

  //     const contactIdToInfo = data1.reduce((acc, item) => {
  //       if (item.contactId && item.campaignName) {
  //         acc[item.contactId] = {
  //           campaignName: normalize(item.campaignName),
  //           brandName: normalize(item.brandName || ""),
  //           paymentStatus: normalize(item.paymentStatus || "pending"),
  //         };
  //       }
  //       return acc;
  //     }, {});

  //     const filteredRefunds = data.filter((refundItem) => {
  //       if (!refundItem.contactId) {
  //         console.log("Skipping refundItem with no contactId:", refundItem);
  //         return false;
  //       }
  //       const info = contactIdToInfo[refundItem.contactId];
  //       if (!info) {
  //         console.log(
  //           "Skipping refundItem with no matching contactId in data1:",
  //           refundItem
  //         );
  //         return false;
  //       }
  //       const campaignMatch =
  //         !campaignFilter || info.campaignName === normalizedCampaignFilter;
  //       const brandMatch =
  //         !brandFilter || info.brandName === normalizedBrandFilter;
  //       return campaignMatch && brandMatch;
  //     });

  //     const refundContactIds = new Set(
  //       data.map((item) => item.contactId).filter(Boolean)
  //     );

  //     const filteredMissingTemplates = data1.filter((orderItem) => {
  //       if (!orderItem.campaignName) {
  //         console.log("Skipping orderItem with no campaignName:", orderItem);
  //         return false;
  //       }
  //       const campaignMatch =
  //         !campaignFilter ||
  //         normalize(orderItem.campaignName) === normalizedCampaignFilter;
  //       const brandMatch =
  //         !brandFilter ||
  //         normalize(orderItem.brandName || "") === normalizedBrandFilter;
  //       const isNotRefunded =
  //         orderItem.contactId && !refundContactIds.has(orderItem.contactId);
  //       return campaignMatch && brandMatch && isNotRefunded;
  //     });

  //     combinedData = [...filteredRefunds, ...filteredMissingTemplates].map(
  //       (item) => ({
  //         ...item,
  //         paymentStatus: normalize(
  //           item.paymentStatus ||
  //           contactIdToInfo[item.contactId]?.paymentStatus ||
  //           "pending"
  //         ),
  //       })
  //     );
  //   } else {
  //     const refundContactIds = new Set(
  //       data.map((item) => item.contactId).filter(Boolean)
  //     );
  //     const uniqueData1 = data1.filter(
  //       (item) => item.contactId && !refundContactIds.has(item.contactId)
  //     );
  //     combinedData = [...data, ...uniqueData1].map((item) => ({
  //       ...item,
  //       paymentStatus: normalize(item.paymentStatus || "pending"),
  //     }));
  //   }

  //   const uniqueByOrderId = Object.values(
  //     combinedData.reduce((acc, item) => {
  //       if (item.order) {
  //         acc[item.order] = item;
  //       }
  //       return acc;
  //     }, {})
  //   );

  //   let finalData = uniqueByOrderId;

  //   if (reasonFilter) {
  //     finalData = finalData.filter((item) =>
  //       item.reasons
  //         ? Array.isArray(item.reasons)
  //           ? item.reasons.includes(reasonFilter)
  //           : item.reasons === reasonFilter
  //         : false
  //     );
  //   }

  //   if (statusFilter) {
  //     finalData = finalData.filter((item) => item.status === statusFilter);
  //   }

  //   // Allow all payment statuses if no filter is selected
  //   if (paymentStatusFilter) {
  //     finalData = finalData.filter(
  //       (item) =>
  //         normalize(item.paymentStatus) === normalize(paymentStatusFilter)
  //     );
  //   }

  //   console.log("Final Filtered Data:", finalData);
  //   console.log(
  //     "Payment Statuses in finalData:",
  //     finalData.map((item) => item.paymentStatus)
  //   );
  //   console.log("Applied Filters:", {
  //     campaignFilter,
  //     brandFilter,
  //     statusFilter,
  //     paymentStatusFilter,
  //   });

  //   setFilteredData([...finalData]);
  // }, [
  //   campaignFilter,
  //   brandFilter,
  //   data,
  //   data1,
  //   reasonFilter,
  //   statusFilter,
  //   paymentStatusFilter,
  // ]);
  useEffect(() => {
    const normalize = (str) => (str ? str.trim().toLowerCase() : "");

    let combinedData = [];

    if (campaignFilter || brandFilter) {
      const normalizedCampaignFilter = normalize(campaignFilter);
      const normalizedBrandFilter = normalize(brandFilter);

      const contactIdToInfo = data1.reduce((acc, item) => {
        if (item.contactId && item.campaignName) {
          acc[item.contactId] = {
            campaignName: normalize(item.campaignName),
            brandName: normalize(item.brandName || ""),
            paymentStatus: normalize(item.paymentStatus || "pending"),
            status: item.status || "Pending Approval", // Ensure status is included
          };
        }
        return acc;
      }, {});

      const filteredRefunds = data.filter((refundItem) => {
        if (!refundItem.contactId) {
          console.log("Skipping refundItem with no contactId:", refundItem);
          return false;
        }
        const info = contactIdToInfo[refundItem.contactId];
        if (!info) {
          console.log(
            "Skipping refundItem with no matching contactId in data1:",
            refundItem
          );
          return false;
        }
        const campaignMatch =
          !campaignFilter || info.campaignName === normalizedCampaignFilter;
        const brandMatch =
          !brandFilter || info.brandName === normalizedBrandFilter;
        return campaignMatch && brandMatch;
      });

      const refundContactIds = new Set(
        data.map((item) => item.contactId).filter(Boolean)
      );

      const filteredMissingTemplates = data1.filter((orderItem) => {
        if (!orderItem.campaignName) {
          console.log("Skipping orderItem with no campaignName:", orderItem);
          return false;
        }
        const campaignMatch =
          !campaignFilter ||
          normalize(orderItem.campaignName) === normalizedCampaignFilter;
        const brandMatch =
          !brandFilter ||
          normalize(orderItem.brandName || "") === normalizedBrandFilter;
        const isNotRefunded =
          orderItem.contactId && !refundContactIds.has(orderItem.contactId);
        return campaignMatch && brandMatch && isNotRefunded;
      });

      // Combine and prioritize refund data status
      combinedData = [...filteredRefunds, ...filteredMissingTemplates].map(
        (item) => {
          const refundItem = data.find((r) => r.order === item.order);
          return {
            ...item,
            paymentStatus: normalize(
              item.paymentStatus ||
              contactIdToInfo[item.contactId]?.paymentStatus ||
              "pending"
            ),
            status: refundItem?.status || item.status || "Pending Approval", // Prioritize refund status
          };
        }
      );
    } else {
      const refundContactIds = new Set(
        data.map((item) => item.contactId).filter(Boolean)
      );
      const uniqueData1 = data1.filter(
        (item) => item.contactId && !refundContactIds.has(item.contactId)
      );
      combinedData = [...data, ...uniqueData1].map((item) => {
        const refundItem = data.find((r) => r.order === item.order);
        return {
          ...item,
          paymentStatus: normalize(item.paymentStatus || "pending"),
          status: refundItem?.status || item.status || "Pending Approval", // Prioritize refund status
        };
      });
    }

    const uniqueByOrderId = Object.values(
      combinedData.reduce((acc, item) => {
        if (item.order) {
          acc[item.order] = item;
        }
        return acc;
      }, {})
    );

    let finalData = uniqueByOrderId;

    if (reasonFilter) {
      finalData = finalData.filter((item) =>
        item.reasons
          ? Array.isArray(item.reasons)
            ? item.reasons.includes(reasonFilter)
            : item.reasons === reasonFilter
          : false
      );
    }

    if (statusFilter) {
      finalData = finalData.filter((item) => item.status === statusFilter);
    }

    if (paymentStatusFilter) {
      finalData = finalData.filter(
        (item) =>
          normalize(item.paymentStatus) === normalize(paymentStatusFilter)
      );
    }

    console.log("Final Filtered Data:", finalData);
    console.log(
      "Statuses in finalData:",
      finalData.map((item) => ({
        order: item.order,
        contactId: item.contactId,
        status: item.status,
        paymentStatus: item.paymentStatus,
      }))
    );
    console.log("Applied Filters:", {
      campaignFilter,
      brandFilter,
      statusFilter,
      paymentStatusFilter,
    });

    setFilteredData([...finalData]);
  }, [
    campaignFilter,
    brandFilter,
    data,
    data1,
    reasonFilter,
    statusFilter,
    paymentStatusFilter,
  ]);

  // const handleApprove = async (contactId) => {
  //   if (!contactId) {
  //     console.error("Missing contactId for approve action");
  //     return;
  //   }
  //   try {
  //     await axios.post(`${Config.API_URL}/api/approve-payment`, { contactId });
  //     setData((prev) =>
  //       prev.map((item) =>
  //         item.contactId === contactId ? { ...item, status: "Approved" } : item
  //       )
  //     );
  //     setData1((prev) =>
  //       prev.map((item) =>
  //         item.contactId === contactId ? { ...item, status: "Approved" } : item
  //       )
  //     );
  //     setFilteredData((prev) =>
  //       prev.map((item) =>
  //         item.contactId === contactId ? { ...item, status: "Approved" } : item
  //       )
  //     );
  //   } catch (error) {
  //     console.error("Error approving contactId:", error);
  //   }
  // };

  // const handleApprove = async (contactId) => {
  //   if (!contactId) {
  //     console.error("Missing contactId for approve action");
  //     return;
  //   }
  //   try {
  //     console.log("API URL:", Config.API_URL);
  //     console.log("Approving contactId:", contactId);
  //      await axios.post(`${Config.API_URL}/api/approve-payment`, { contactId });
  //     setData((prev) => {
  //       const updated = prev.map((item) =>
  //         item.contactId === contactId ? { ...item, status: "Approved" } : item
  //       );
  //       console.log("Updated data:", updated);
  //       return updated;
  //     });
  //     setData1((prev) => {
  //       const updated = prev.map((item) =>
  //         item.contactId === contactId ? { ...item, status: "Approved" } : item
  //       );
  //       console.log("Updated data1:", updated);
  //       return updated;
  //     });
  //     setFilteredData((prev) => {
  //       const updated = prev.map((item) =>
  //         item.contactId === contactId ? { ...item, status: "Approved" } : item
  //       );
  //       console.log("Updated filteredData:", updated);
  //       return updated;
  //     });
  //     alert("Payment approved successfully!");
  //   } catch (error) {
  //     console.error("Error approving contactId:", error);
  //     if (error.response?.status === 404) {
  //       alert("Approval endpoint not found. Please contact the administrator.");
  //     } else {
  //       alert("Failed to approve payment. Please try again.");
  //     }
  //   }
  // };






  // const handleApprove = async (contactId, orderId) => {
  //   console.log("Approving order with orderId:", orderId);
  //   console.log("Approving order with contactId:", contactId);

  //   if (!orderId) {
  //     alert("No orderId found in this record!");
  //     return;
  //   }

  //   try {
  //     await axios.post(`${Config.API_URL}/api/approve-order`, { orderId });

  //     setData((prev) =>
  //       prev.map((item) =>
  //         item.order === orderId ? { ...item, status: "Approved" } : item
  //       )
  //     );

  //     alert("Order approved and email sent successfully!");
  //   } catch (error) {
  //     console.error("Error approving order:", error);
  //     alert("Failed to approve order. Please try again.");
  //   }
  // };


  // const handleApprove = async (orderId, contactId) => {
  //   console.log("Approving order with orderId:", orderId);
  //   console.log("Approving order with contactId:", contactId);

  //   try {
  //     if (!orderId || orderId.trim() === "" || orderId === null) {
  //       // ✅ Case: only contactId exists → approve payment
  //       if (!contactId) {
  //         alert("No contactId found for payment approval!");
  //         return;
  //       }

  //       await axios.post(`${Config.API_URL}/api/approve-payment`, { contactId });

  //       setData((prev) =>
  //         prev.map((item) =>
  //           item.contactId === contactId ? { ...item, status: "Approved" } : item
  //         )
  //       );

  //       alert("Payment approved and email sent successfully!");
  //     } else {
  //       // ✅ Case: orderId exists → approve order
  //       await axios.post(`${Config.API_URL}/api/approve-order`, { orderId });

  //       setData((prev) =>
  //         prev.map((item) =>
  //           item.order === orderId ? { ...item, status: "Approved" } : item
  //         )
  //       );

  //       alert("Order approved and email sent successfully!");
  //     }
  //   } catch (error) {
  //     console.error("Error approving:", error);
  //     alert("Failed to approve. Please try again.");
  //   }
  // };


  const handleApprove = async (orderId, contactId) => {
    console.log("Approving order with orderId:", orderId);
    console.log("Approving order with contactId:", contactId);

    try {
      let endpoint, id, idType;

      // Determine which endpoint and ID to use
      if (!orderId || orderId.trim() === "" || orderId === null) {
        // Use payment approval
        if (!contactId) {
          alert("No contactId found for payment approval!");
          return;
        }
        endpoint = "/api/approve-payment";
        id = contactId;
        idType = "contactId";
      } else {
        // Use order approval
        endpoint = "/api/approve-order";
        id = orderId;
        idType = "order";
      }

      // Make API call
      await axios.post(`${Config.API_URL}${endpoint}`, {
        [idType === "contactId" ? "contactId" : "orderId"]: id,
      });

      // Update all three state variables
      const updateFunction = (item) =>
        item[idType] === id ? { ...item, status: "Approved" } : item;

      setData((prev) => prev.map(updateFunction));
      setData1((prev) => prev.map(updateFunction));
      setFilteredData((prev) => prev.map(updateFunction));

      alert(
        `${idType === "contactId" ? "Payment" : "Order"
        } approved and email sent successfully!`
      );
    } catch (error) {
      console.error("Error approving:", error);

      if (error.response?.status === 404) {
        alert("Approval endpoint not found. Please contact the administrator.");
      } else {
        alert("Failed to approve. Please try again.");
      }
    }
  };

  // const handleOnHold = async (contactId, orderId) => {
  //   console.log("On-holding order with orderId:", orderId);
  //   console.log("On-holding order with contactId:", contactId);
  //   if (!contactId) {
  //     console.error("Missing contactId for on-hold action");
  //     return;
  //   }
  //   try {
  //     // TODO: Verify endpoint with backend
  //     await axios.post(`${Config.API_URL}/api/on-hold-payment`, { contactId });
  //     setData((prev) =>
  //       prev.map((item) =>
  //         item.contactId === contactId ? { ...item, status: "On-hold" } : item
  //       )
  //     );
  //     setData1((prev) =>
  //       prev.map((item) =>
  //         item.contactId === contactId ? { ...item, status: "On-hold" } : item
  //       )
  //     );
  //     setFilteredData((prev) =>
  //       prev.map((item) =>
  //         item.contactId === contactId ? { ...item, status: "On-hold" } : item
  //       )
  //     );
  //   } catch (error) {
  //     console.error("Error putting on hold contactId:", error);
  //   }
  // };


  const handleOnHold = async (contactId, orderId) => {
    console.log("On-holding order with orderId:", orderId);
    console.log("On-holding order with contactId:", contactId);

    if (!contactId || !orderId) {
      alert("Missing contactId or orderId for on-hold action");
      return;
    }

    try {
      await axios.post(`${Config.API_URL}/api/on-hold-payment`, {
        contactId,
        orderId,
      });

      // Update local state instantly
      setData((prev) =>
        prev.map((item) =>
          item.contactId === contactId && item.order === orderId
            ? { ...item, status: "On-hold" }
            : item
        )
      );

      setData1((prev) =>
        prev.map((item) =>
          item.contactId === contactId && item.order === orderId
            ? { ...item, status: "On-hold" }
            : item
        )
      );

      setFilteredData((prev) =>
        prev.map((item) =>
          item.contactId === contactId && item.order === orderId
            ? { ...item, status: "On-hold" }
            : item
        )
      );

      alert("Order put on hold successfully!");
    } catch (error) {
      console.error("Error putting on hold:", error);
      alert("Failed to put on hold. Please try again.");
    }
  };

  const openRejectModal = (item) => {
    setSelectedItem(item);
    setSelectedReasons([]);
    setCustomReason("");
    setShowModal(true);
  };

  const closeRejectModal = () => {
    setShowModal(false);
    setSelectedItem(null);
    setCustomReason("");
    setSelectedReasons([]);
  };

  const toggleReason = (reason) => {
    setSelectedReasons((prev) =>
      prev.includes(reason)
        ? prev.filter((r) => r !== reason)
        : [...prev, reason]
    );
  };

  const handleSubmitRejection = async () => {
    if (!selectedItem) return;

    const orderId = selectedItem.orderId || selectedItem.order;
    if (!orderId) {
      console.error("Missing orderId or order in selectedItem", selectedItem);
      return;
    }

    const finalReasons = selectedReasons.includes("Others")
      ? [...selectedReasons.filter((r) => r !== "Others"), customReason]
      : selectedReasons;

    try {
      await axios.post(`${Config.API_URL}/api/reject-payment`, {
        orderId,
        reasons: finalReasons,
      });

      setData((prev) =>
        prev.map((item) =>
          item.orderId === orderId
            ? { ...item, status: "Canceled", reasons: finalReasons }
            : item
        )
      );

      setData1((prev) =>
        prev.map((item) =>
          item.orderId === orderId
            ? { ...item, status: "Canceled", reasons: finalReasons }
            : item
        )
      );

      setFilteredData((prev) =>
        prev.map((item) =>
          item.orderId === orderId
            ? { ...item, status: "Canceled", reasons: finalReasons }
            : item
        )
      );
    } catch (error) {
      console.error("Error canceling order:", error);
    }

    closeRejectModal();
  };

  // Sorting handler
  const handleSortByDate = () => {
    const newSortOrder = sortOrder === "asc" ? "desc" : "asc";
    const sorted = [...filteredData].sort((a, b) => {
      const dateA = data1.find((d) => d.order === a.order)?.date;
      const dateB = data1.find((d) => d.order === b.order)?.date;
      const parsedDateA = dateA ? new Date(dateA) : new Date(0);
      const parsedDateB = dateB ? new Date(dateB) : new Date(0);
      return newSortOrder === "asc"
        ? parsedDateA - parsedDateB
        : parsedDateB - parsedDateA;
    });

    setFilteredData(sorted);
    setSortOrder(newSortOrder);
  };

  // Download CSV function
  const downloadCSV = (dataToDownload, filename) => {
    const csvHeaders = [
      "Campaign Name",
      "User Name",
      "Order ID",
      "Quantity",
      "Invoice Number",
      "Product Amount",
      "Deliverable Link",
      "Bank Name",
      "Ifsc",
      "Beneficiary Name",
      "Account Number",
      "UPI Number",
      "Managers",
      "Date",
      "Student",
      "College",
      "Whatsapp Group",
      "Pin Code",
      "City",
      "Product Name",
      "Order Delivered Screen Shot",
      "Submitting Rating SS",
      "Full Name",
      "Facebook",
      "Twitter",
      "YouTube",
      "Custom Social",
      "Gender",
      "Whatsapp",
      "Phone",
      "Custom MarketPlace",
      "Custom Review",
      "Custom Profile Link",
      "Email",
      "Status",
      "Payment Status",
    ];

    const csvRows = dataToDownload.map((item) => {
      const matchedData = data1.find((d) => d.order === item.order);
      return [
        matchedData?.campaignName || "",
        matchedData?.brandName || "", // Added Brand
        matchedData?.AuthInstagram || "",
        item.order || "",
        item.quantity || "",
        item.inputValue1 || "",
        matchedData?.productAmount || "",
        item.inputValue2 || "",
        matchedData?.BankName || "",
        item.ifsc || "",
        item.BeneficiaryName || "",
        item.accountNumber || "",
        item.UPI || "",
        Array.isArray(matchedData?.managers)
          ? matchedData.managers.join(", ")
          : "",
        matchedData?.date || "",
        String(matchedData?.student) === "true" ? "Yes" : "No",
        matchedData?.collegeName || "",
        item.whatsappGroup || "",
        matchedData?.pinCode || "",
        matchedData?.city || "",
        item.inputValue || "",
        item.inputValue3 ? `${Config.API_URL}/${item.inputValue3}` : "",
        item.inputValue4 ? `${Config.API_URL}/${item.inputValue4}` : "",
        matchedData?.FullName || "",
        matchedData?.AuthFacebook || "",
        matchedData?.AuthTwitter || "",
        matchedData?.AuthYouTube || "",
        matchedData?.AuthCustomSocial || "",
        matchedData?.gender || "",
        matchedData?.whatsapp || "",
        matchedData?.Phone || "",
        matchedData?.customMarketPlaceName || "",
        matchedData?.review || "",
        matchedData?.customForum || "",
        matchedData?.email || "",
        item.status || "Pending Approval",
        item.paymentStatus || "",
      ].map((field) => `"${String(field).replace(/"/g, '""')}"`);
    });

    const csvContent = [
      csvHeaders.join(","),
      ...csvRows.map((row) => row.join(",")),
    ].join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    link.click();
    URL.revokeObjectURL(url);
  };

  // Status and reason options
  // const statusOptions = ["Failed", "Processed", "Queue"];
  const statusOptions = ["Pending", "Failed", "Processed", "Queue"];
  const approve = ["Pending Approval", "Approved", "Canceled", "On-hold"];
  const reason = [
    "Everything is Okay",
    "Missing Item(s): Order Screenshot",
    "Missing Item(s): Delivered Screenshot",
    "Missing Item(s): Review / Rating Screenshot",
    "Missing Item(s): Live Review Screenshot",
    "Missing Item(s): Invoice",
    "Missing Item(s): Live Review Link",
    "Mismatched Details: Of Order ID",
    "Mismatched Details: Of Product ID",
    "Mismatched Details: Of Product Amount",
    "Mismatched Details: Of Order Date",
    "Mismatched Details: Of Product",
    "Mismatched Details: Of Order Screenshot",
    "Mismatched Details: Of Review Screenshot and Live Review",
    "Mismatched Details: Of Reviewer Name",
    "Suspicious Activity: In Order Screenshot",
    "Suspicious Activity: In Delivered Screenshot",
    "Suspicious Activity: In the Submitted Review / Rating Screenshot",
    "Suspicious Activity: In the Live Review Screenshot",
    "Suspicious Activity: In Live Review Screenshot(Review not verified)",
    "Suspicious Activity: In Invoice(PDF / Screenshot)",
    "Suspicious Activity: In Order Status(Product returned)",
    "Suspicious Activity: In Order Status(Order canceled)",
    "Suspicious Activity: In Order Status(Order not delivered yet)",
    "Wrong Documents / Details Submitted: Order Screenshot",
    "Wrong Documents / Details Submitted: Delivered Screenshot",
    "Wrong Documents / Details Submitted: Review / Rating Screenshot",
    "Wrong Documents / Details Submitted: Live Review Screenshot",
    "Wrong Documents / Details Submitted: Invoice",
    "Wrong Documents / Details Submitted: Live Review Link",
    "Wrong Documents / Details Submitted, Live Review Screenshot(Not from logged in account)",
    "Review Quality: Only Rating(No review)",
    "Review Quality: Only Rating Required No review needed)",
    "Review Quality: Very Short Review",
    "Review Quality: Incorrect Rating",
    "Review Quality: Review with Title Only(No Description)",
    "Review Quality: Missing Video",
    "Review Quality: Missing Image",
    "Review Quality: Missing Keywords",
    "Review Quality: Wrong Gender",
    "Screenshot Quality(Resolution) is bad: Order Screenshot",
    "Screenshot Quality(Resolution) is bad: Delivered Screenshot",
    "Screenshot Quality(Resolution) is bad: Review / Rating Screenshot",
    "Screenshot Quality(Resolution) is bad: Live Review Screenshot",
    "Screenshot Quality(Resolution) is bad: Invoice",
    "Screenshot Completeness(Not Full Page): Order Screenshot",
    "Screenshot Completeness(Not Full Page): Delivered Screenshot",
    "Screenshot Completeness(Not Full Page): Review / Rating Screenshot",
    "Screenshot Completeness(Not Full Page): Live Review Screenshot",
    "Screenshot Completeness(Not Full Page): Invoice Duplicate",
    "Shipping Fee Issue: Shipping fee exceeds the limit of the standard fee",
  ];

  // Mouse drag scrolling
  let isDown = false;
  let startX;
  let scrollLeft;

  const handleMouseDown = (e) => {
    const slider = e.currentTarget;
    isDown = true;
    slider.classList.add("active");
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  };

  const handleMouseLeave = (e) => {
    isDown = false;
    e.currentTarget.classList.remove("active");
  };

  const handleMouseUp = (e) => {
    isDown = false;
    e.currentTarget.classList.remove("active");
  };

  const handleMouseMove = (e) => {
    if (!isDown) return;
    e.preventDefault();
    const slider = e.currentTarget;
    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * 2;
    slider.scrollLeft = scrollLeft - walk;
  };

  return (
    <div className="table-component container mt-5">
      <style>
        {`
          .table-component .table-container {
            max-width: 100%;
            overflow-x: auto;
            cursor: grab;
          }
          .table-component .table-container.active {
            cursor: grabbing;
          }
          .table-component .table {
            width: 100%;
            border-collapse: collapse;
          }
          .table-component .table th,
          .table-component .table td {
            padding: 8px;
            border: 1px solid #ddd;
            text-align: left;
          }
          .table-component .table th {
            background-color: #808080;
            cursor: pointer;
          }
          .table-component .table th.customStyle:hover {
            background-color: #e0e0e0;
          }
          .table-component .dropdown {
            padding: 5px;
            margin-left: 10px;
            border-radius: 4px;
            border: 1px solid #ccc;
          }
          .table-component .filters {
            display: flex;
            align-items: center;
            margin-bottom: 15px;
          }
          .table-component .button {
            padding: 8px 12px;
            border: none;
            border-radius: 4px;
            cursor: pointer;
            margin-right: 10px;
          }
          .table-component .button.is-primary {
            background-color: #3273dc;
            color: white;
          }
          .table-component .button.is-primary.is-light {
            background-color: #eff1fa;
            color: #3273dc;
          }
          .table-component .button.is-danger {
            background-color: #ff3860;
            color: white;
          }
          .table-component .button.is-danger.is-light {
            background-color: #ffecf0;
            color: #ff3860;
          }
          .table-component .button.is-warning {
            background-color: #ffdd57;
            color: #333;
          }
          .table-component .button.is-warning.is-light {
            background-color: #fff5cc;
            color: #333;
          }
          .table-component .button.is-info {
            background-color: #209cee;
            color: white;
          }
          .table-component .button:disabled {
            opacity: 0.5;
            cursor: not-allowed;
          }
        `}
      </style>

      {/* Download Buttons and Reset Filters */}
      <div className="mb-3">
        <button
          className="button is-info"
          onClick={() => downloadCSV(filteredData, "filtered_data.csv")}
          disabled={loading}
        >
          Download Filtered Data as CSV
        </button>
        <button
          className="button is-info"
          onClick={() => {
            const refundContactIds = new Set(
              data.map((item) => item.contactId).filter(Boolean)
            );
            const uniqueData1 = data1.filter(
              (item) => item.contactId && !refundContactIds.has(item.contactId)
            );
            const allData = [...data, ...uniqueData1];
            const uniqueAll = Object.values(
              allData.reduce((acc, item) => {
                if (item.order) acc[item.order] = item;
                return acc;
              }, {})
            );
            downloadCSV(uniqueAll, "all_data.csv");
          }}
          disabled={loading}
        >
          Download All Data as CSV
        </button>
        <button className="button is-warning" onClick={handleResetFilters}>
          Reset Filters
        </button>
      </div>

      {/* Loading State */}
      {loading && <p>Loading data...</p>}

      {/* Filters */}
      {!loading && (
        <>
          <div className="filters">
            <label htmlFor="campaignFilter" className="mr-2">
              Filter by Campaign:
            </label>
            <select
              id="campaignFilter"
              value={campaignFilter}
              onChange={handleCampaignChange}
              className="dropdown"
            >
              <option value="">All Campaigns</option>
              {campaigns.map((campaign, index) => (
                <option key={index} value={campaign}>
                  {campaign}
                </option>
              ))}
            </select>
          </div>
          <div className="filters">
            <label htmlFor="brandFilter" className="mr-2">
              Filter by Brand:
            </label>
            <select
              id="brandFilter"
              value={brandFilter}
              onChange={handleBrandChange}
              className="dropdown"
            >
              <option value="">All Brands</option>
              {brands.map((brand, index) => (
                <option key={index} value={brand}>
                  {brand}
                </option>
              ))}
            </select>
          </div>
          <div className="filters">
            <label htmlFor="reasonFilter" className="mr-2">
              Filter by Reason:
            </label>
            <select
              id="reasonFilter"
              value={reasonFilter}
              onChange={handlereasonChange}
              className="dropdown"
            >
              <option value="">All Reasons</option>
              {reason.map((reason, index) => (
                <option key={index} value={reason}>
                  {reason}
                </option>
              ))}
            </select>
          </div>
          <div className="filters">
            <label htmlFor="statusFilter" className="mr-2">
              Filter by Application Status:
            </label>
            <select
              id="statusFilter"
              value={statusFilter}
              onChange={handlestatusChange}
              className="dropdown"
            >
              <option value="">All Statuses</option>
              {approve.map((status, index) => (
                <option key={index} value={status}>
                  {status}
                </option>
              ))}
            </select>
          </div>
          <div className="filters">
            <label htmlFor="paymentStatusFilter" className="mr-2">
              Filter by Payment Status:
            </label>
            <select
              id="paymentStatusFilter"
              value={paymentStatusFilter}
              onChange={handlePaymentStatusChange}
              className="dropdown"
            >
              <option value="">All Payment Statuses</option>
              {statusOptions.map((status, index) => (
                <option key={index} value={status}>
                  {status}
                </option>
              ))}
            </select>
          </div>
        </>
      )}

      {/* Table */}
      {!loading && (
        <div
          className="table-container"
          onMouseDown={handleMouseDown}
          onMouseLeave={handleMouseLeave}
          onMouseUp={handleMouseUp}
          onMouseMove={handleMouseMove}
        >
          <table className="table">
            <thead>
              <tr>
                <th className="customStyle">Campaign Name</th>
                <th className="customStyle">Brand Name</th>
                <th className="customStyle">User Name</th>
                <th className="customStyle">Order ID</th>
                <th className="customStyle">Quantity</th>
                <th className="customStyle">Invoice Number</th>
                <th className="customStyle">Product Amount</th>
                <th className="customStyle">Deliverable Link</th>
                <th className="customStyle">Bank Name</th>
                <th className="customStyle">Ifsc</th>
                <th className="customStyle">Beneficiary Name</th>
                <th className="customStyle">Account Number</th>
                <th className="customStyle">UPI Number</th>
                <th className="customStyle">Managers</th>
                <th className="customStyle" onClick={handleSortByDate}>
                  Date {sortOrder === "asc" ? "↑" : "↓"}
                </th>
                <th className="customStyle">Student</th>
                <th className="customStyle">College</th>
                <th className="customStyle">Whatsapp Group</th>
                <th className="customStyle">Pin Code</th>
                <th className="customStyle">City</th>
                <th className="customStyle">Product Name</th>
                <th className="customStyle">Order Delivered Screen Shot</th>
                <th className="customStyle">Submitting Rating SS</th>
                <th className="customStyle">Seller Feedback Screenshot </th>
                <th className="customStyle">Invoice Pdf </th>
                <th className="customStyle">Full Name</th>
                <th className="customStyle">Facebook</th>
                <th className="customStyle">Twitter</th>
                <th className="customStyle">YouTube</th>
                {/* <th className="customStyle">Custom Social</th> */}
                <th className="customStyle">Gender</th>
                <th className="customStyle">Whatsapp</th>
                <th className="customStyle">Phone</th>
                <th className="customStyle">Custom MarketPlace</th>
                <th className="customStyle">Custom Review</th>
                {/* <th className="customStyle">Custom Profile Link</th> */}
                <th className="customStyle">Email</th>
                <th className="customStyle">Actions</th>
                <th className="customStyle">Status</th>
                <th className="customStyle">Payment Status</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.length > 0 ? (
                filteredData.map((item, index) => {
                  const matchedData = data1.find((d) => d.order === item.order);
                  return (
                    <tr key={index}>
                      <td className="customStyle">
                        {matchedData?.campaignName || ""}
                      </td>
                      <td className="customStyle">
                        {matchedData?.brandName || ""}
                      </td>
                      <td className="customStyle">
                        {matchedData?.AuthInstagram ? (
                          <a
                            href={`https://www.instagram.com/${matchedData.AuthInstagram}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              color: "blue",
                              textDecoration: "underline",
                            }}
                          >
                            {matchedData.AuthInstagram}
                          </a>
                        ) : (
                          ""
                        )}
                      </td>
                      <td className="customStyle">{item.order || ""}</td>
                      <td className="customStyle">
                        {matchedData?.quantity || ""}
                      </td>
                      <td className="customStyle">
                        {item.invoiceNumber || ""}
                      </td>
                      <td className="customStyle">
                        {matchedData?.productAmount || ""}
                      </td>
                      <td className="customStyle">{item.inputValue2 || ""}</td>
                      <td className="customStyle">
                        {matchedData?.BankName || ""}
                      </td>
                      <td className="customStyle">{item.ifsc || ""}</td>
                      <td className="customStyle">
                        {item.beneficiaryName || ""}
                      </td>
                      <td className="customStyle">
                        {item.accountNumber || ""}
                      </td>
                      <td className="customStyle">{item.UPI || ""}</td>
                      <td className="customStyle">
                        {Array.isArray(matchedData?.managers)
                          ? matchedData.managers.join(", ")
                          : ""}
                      </td>
                      <td className="customStyle">{matchedData?.date || ""}</td>
                      <td className="customStyle">
                        {String(matchedData?.student) === "true" ? "Yes" : "No"}
                      </td>
                      <td className="customStyle">
                        {matchedData?.collegeName || ""}
                      </td>
                      <td className="customStyle">
                        {item.whatsappGroup || ""}
                      </td>
                      <td className="customStyle">
                        {matchedData?.pinCode || ""}
                      </td>
                      <td className="customStyle">{matchedData?.city || ""}</td>
                      <td className="customStyle">
                        {matchedData?.productName || ""}
                      </td>
                      <td className="customStyle">
                        {item.inputValue3 && (
                          <a
                            href={`${Config.API_URL}/${item.inputValue3}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src={`${Config.API_URL}/${item.inputValue3}`}
                              alt="Order Screenshot"
                              style={{ width: "100px", height: "auto" }}
                            />
                          </a>
                        )}
                      </td>
                      <td className="customStyle">
                        {item.inputValue4 && (
                          <a
                            href={`${Config.API_URL}/${item.inputValue4}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src={`${Config.API_URL}/${item.inputValue4}`}
                              alt="Rating Screenshot"
                              style={{ width: "100px", height: "auto" }}
                            />
                          </a>
                        )}
                      </td>
                      <td className="customStyle">
                        {item.sellarFeedbackScreenshot && (
                          <a
                            href={`${Config.API_URL}/${item.sellarFeedbackScreenshot}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src={`${Config.API_URL}/${item.sellarFeedbackScreenshot}`}
                              alt="Screenshot 2"
                              style={{ width: "100px", height: "auto" }}
                            />
                          </a>
                        )}
                      </td>

                      <td className="customStyle">
                        {item.invoiceReceived && (
                          <a
                            href={`${Config.API_URL}/${item.invoiceReceived}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src={`${Config.API_URL}/${item.invoiceReceived}`}
                              alt="Screenshot 2"
                              style={{ width: "100px", height: "auto" }}
                            />
                          </a>
                        )}
                      </td>

                      <td className="customStyle">
                        {matchedData?.FullName || ""}
                      </td>
                      <td className="customStyle">
                        {matchedData?.AuthFacebook ? (
                          <a
                            href={`https://www.facebook.com/${matchedData.AuthFacebook}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              color: "blue",
                              textDecoration: "underline",
                            }}
                          >
                            {matchedData.AuthFacebook}
                          </a>
                        ) : (
                          ""
                        )}
                      </td>
                      <td className="customStyle">
                        {matchedData?.AuthTwitter ? (
                          <a
                            href={`https://www.x.com/${matchedData.AuthTwitter}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              color: "blue",
                              textDecoration: "underline",
                            }}
                          >
                            {matchedData.AuthTwitter}
                          </a>
                        ) : (
                          ""
                        )}
                      </td>
                      <td className="customStyle">
                        {matchedData?.AuthYouTube ? (
                          <a
                            href={`https://www.youtube.com/${matchedData.AuthYouTube}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              color: "blue",
                              textDecoration: "underline",
                            }}
                          >
                            {matchedData.AuthYouTube}
                          </a>
                        ) : (
                          ""
                        )}
                      </td>
                      {/* <td className="customStyle">
                        {item?.AuthCustomSocial || ""}
                      </td> */}
                      <td className="customStyle">
                        {matchedData?.gender || ""}
                      </td>
                      <td className="customStyle">
                        {matchedData?.whatsapp || ""}
                      </td>
                      <td className="customStyle">
                        {matchedData?.Phone || ""}
                      </td>
                      <td className="customStyle">
                        {matchedData?.customMarketPlaceName || ""}
                      </td>
                      <td className="customStyle">
                        {matchedData?.review || ""}
                      </td>
                      {/* <td className="customStyle">
                        {matchedData?.customForum || ""}
                      </td> */}
                      <td className="customStyle">
                        {matchedData?.email || ""}
                      </td>
                      <td className="customStyle">
                        {/* <button
                          onClick={() => handleApprove(item.contactId, item.order)}
                          disabled={item.status === "Approved"}
                          className={`button is-primary ${
                            item.status === "Approved" ? "is-light" : ""
                          }`}
                        >
                          Approve
                        </button> */}

                        <button
                          onClick={() =>
                            handleApprove(item.order, item.contactId)
                          }
                          disabled={item.status === "Approved"}
                          className={`button is-primary ${item.status === "Approved" ? "is-light" : ""
                            }`}
                        >
                          {item.status === "Approved" ? "Approved" : "Approve"}
                        </button>

                        <button
                          onClick={() => openRejectModal(item)}
                          disabled={
                            item.status !== "On-hold" &&
                            item.status !== "Pending Approval"
                          }
                          className={`button is-danger ${item.status === "Canceled" ? "is-light" : ""
                            }`}
                        >
                          Cancel
                        </button>
                        {/* <button
                          onClick={() => handleOnHold(item.contactId, item.order)}
                          disabled={
                            item.status !== "Canceled" &&
                            item.status !== "Pending Approval"
                          }
                          className={`button is-warning ${
                            item.status === "On-hold" ? "is-light" : ""
                          }`}
                        >
                          On-hold
                        </button> */}
                        <button
                          onClick={() =>
                            handleOnHold(item.contactId, item.order)
                          }
                          disabled={
                            item.status !== "Canceled" &&
                            item.status !== "Pending Approval"
                          }
                          className={`button is-warning ${item.status === "On-hold" ? "is-light" : ""
                            }`}
                        >
                          On-hold
                        </button>
                      </td>
                      <td className="customStyle">
                        {item.status === "Canceled" ? (
                          <>
                            <strong>Rejected</strong>
                            {item.reasons?.length > 0 && (
                              <ul
                                style={{
                                  marginTop: "4px",
                                  paddingLeft: "16px",
                                  color: "red",
                                  fontSize: "12px",
                                }}
                              >
                                {item.reasons.map((reason, index) => (
                                  <li key={index}>- {reason}</li>
                                ))}
                              </ul>
                            )}
                          </>
                        ) : (
                          <strong>{item.status || "Pending Approval"}</strong>
                        )}
                      </td>
                      <td className="customStyle">
                        {item.paymentStatus || ""}
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="35">No data available</td>
                </tr>
              )}
            </tbody>
          </table>
          <RejectModal
            isOpen={showModal}
            onClose={closeRejectModal}
            onSubmit={handleSubmitRejection}
            selectedReasons={selectedReasons}
            toggleReason={toggleReason}
            customReason={customReason}
            setCustomReason={setCustomReason}
          />
        </div>
      )}
    </div>
  );
};

export default Table;